const en = {
  // common
  'Loading...': 'Loading...',
  'No data': 'No data',
  Yes: 'Yes',
  No: 'No',
  Imperial: 'Imperial',
  Metric: 'Metric',
  Bar: 'bar',
  bar: 'bar',
  'm^3/min': 'm^3/min',
  'm3/min': 'm<0>3</0>/min',
  kW: 'kW',
  'SPECIFIC POWER': 'SPECIFIC POWER',
  pressure: 'Pressure',
  'operation mode': 'Operation Mode',
  flow: 'flow',
  power: 'Power',
  PSI: 'psi',
  psi: 'psi',
  CFM: 'CFM',
  cfm: 'cfm',
  RPM: 'RPM',
  temperature: 'temperature',
  Temperature: 'Temperature',
  Temp: 'Temp',
  Celsius: 'Celsius',
  celsius: 'celsius',
  Fahrenheit: 'Fahrenheit',
  fahrenheit: 'fahrenheit',
  '°C': '°C',
  '°F': '°F',
  current: 'current',
  'Oil temperature': 'Oil temperature',
  'Dew point temperature': 'Dew point temperature',
  'Inverter speed': 'Inverter speed',
  'Run hours': 'Run hours',
  'Load hours': 'Load hours',
  '_ _': '_ _',
  'N/A': 'N/A',
  'Water Flow': 'Water Flow',
  'Inlet Water Temperature': 'Inlet Water Temperature',
  'Outlet Water Temperature': 'Outlet Water Temperature',

  // login page
  'Welcome to EcoPlant': 'Welcome to EcoPlant',
  'For technical support email us at:': 'For technical support email us at:',
  'EcoPlant 2025. All right reserved.': 'EcoPlant 2025. All right reserved.',
  'Email Address': 'Email Address',
  Password: 'Password',
  Login: 'Login',
  'Enter a verification code': 'Enter a verification code',
  'Send Again': 'Send Again',
  Done: 'Done',
  Cancel: 'Cancel',
  'SMS with a verification code was sent to your phone': 'SMS with a verification code was sent to your phone',
  'Forgot Password': 'Forgot Password',
  'Sign in with Single Sign On': 'Sign in with Single Sign On',

  // side menu
  "Eco plant's logo": "Eco plant's logo",
  'Log out': 'Log out',

  // eco score card
  'ECO RATING': 'ECO RATING',
  'Specific power': 'Specific power',
  'kW/(m^3/min)': 'kW/(m^3/min)',
  'kW/(m3/min)': 'kW/(m<0>3</0>/min)',
  'm^3': 'm<0>3</0>',
  'ft^3': 'ft<0>3</0>',
  'kW/100CFM': 'kW/100CFM',

  // alerts
  ALERTS: 'ALERTS',
  All: 'All',
  Service: 'Service',
  service: 'service',
  Warning: 'Warning',
  warning: 'warning',
  Shutdown: 'Shutdown',
  shutdown: 'shutdown',
  Expired: 'Expired',
  Custom: 'Custom',
  Manufacturer: 'Manufacturer',
  'No more alerts to show': 'No more alerts to show',
  'No alerts to show for this severity type.': 'No alerts to show for this severity type.',
  RECOMMENDATION: 'RECOMMENDATION',
  'No archived alerts yet.': 'No archived alerts yet.',
  'Or contact us via:': 'Or contact us via:',
  noAlertsToShow: 'No alerts to show. You can view old alerts under the <1>Archive tab</1>.',
  'Archive Alert': 'Archive Alert',
  'Unarchive alert failed': 'Unarchive alert failed',
  "View Alert record's rule (logic)": "View Alert record's rule (logic)",
  'Auto & manually archived alerts': 'Auto & manually archived alerts',
  'Received during maintenance': 'Received during maintenance',
  'This alert record was triggered while the compressor was In-Maintenance':
    'This alert record was triggered while the compressor was In-Maintenance',
  SSOLoginNotEnabled:
    'Your organization has not enabled SSO login for your email address. Please use password authentication method instead',
  LoginFailureNoStations:
    'Your login attempt was unsuccessful because you currently have no stations assigned to your account. Please contact your IT administrator to request access to the necessary stations.',
  LoginFailurePasswordError:
    'Your login attempt was unsuccessful. System Error: {{error}} If your organization uses Single Sign-On (SSO), please try logging in using the SSO option.',
  LoginFailureUnhautorizedSSO:
    'Your login attempt was unsuccessful because your SSO account is not authorized. Please try logging in with another SSO account or use the password login option.',

  // main
  Map: 'Map',
  Trends: 'Trends',
  Investigation: 'Investigation',
  'Reset zoom': 'Reset zoom',
  VALUE: 'value',
  PLANT: 'plant',
  REPORTS: 'reports',
  ENGINE: 'engine',
  OFFERING: 'offering',
  SETTINGS: 'settings',

  // MapKPI
  'Value may depend on multiple sensors and average values over time.':
    'Value may depend on multiple sensors and average values over time.',
  moreDetailsInStationControl: 'See more details on the Station Control Center tab',
  moreDetailsInValueDashboard: 'See more details in the Value Dashboard screen',
  'Compressor kW based calculation': 'Compressor kW based calculation',
  'Flow based on Flow sensor avg at the end of the station': 'Flow based on Flow sensor avg at the end of the station',
  'Pressure Drop': 'Pressure Drop',

  // Trends
  UTC: 'UTC',
  Yesterday: 'Yesterday',
  'Last 24 hours': 'Last 24 hours',
  'Last 7 days': 'Last 7 days',
  'Last 30 days': 'Last 30 days',
  'Last 90 days': 'Last 90 days',

  Pressure: 'Pressure',
  Flow: 'Flow',
  Power: 'Power',
  'Specific Power': 'Specific Power',
  'specific power': 'specific power',
  'Oil temp': 'Oil temp',
  'Dew temp': 'Dew temp',

  // trends - tooltip
  second: 'second',
  seconds: 'seconds',
  minute: 'minute',
  minutes: 'minutes',
  Hour: 'Hour',
  Hours: 'Hours',
  hour: 'hour',
  hours: 'hours',
  day: 'day',
  week: 'week',
  month: 'month',
  '{{value}} {{unit}} average': '{{value}} {{unit}} average',

  // device modal
  Run: 'Run',
  Load: 'Load',
  LOAD: 'Load',
  Unload: 'Unload',
  UNLOAD: 'Unload',
  Off: 'Off',
  OFF: 'Off',
  ON: 'On',
  On: 'On',
  Loading: 'Loading',
  Unloading: 'Unloading',
  Disconnected: 'Disconnected',
  disconnected: 'Disconnected',
  'No State': 'No State',
  NoState: 'No State',
  NO_STATE: 'no state',
  capacity: 'capacity',
  Liter: 'Liter',
  liter: 'liter',
  Gallon: 'Gallon',
  gallon: 'gallon',
  'pipe diameter': 'pipe diameter',
  'pipe material': 'pipe material',
  inch: 'inch',
  mm: 'mm',
  'dew point temperature': 'dew point temperature',
  activity: 'activity',
  Hp: 'Hp',

  STOPPED: 'Stopped',
  Connected: 'Connected',
  connected: 'Connected',
  'Not connected': 'Not connected',
  connectivity: 'Connectivity',
  CONNECTION_ERROR: 'connection error',

  Auto: 'Auto',
  Manual: 'Manual',
  Controllable: 'Controllable',
  CONTROLLABLE: 'Controllable',
  ON_OFF: 'On/Off',
  NOTCONTROLLABLE: 'Not Controllable',
  NOT_CONTROLLABLE: 'Not Controllable',
  'On/Off': 'On/Off',
  'Not controllable': 'Not Controllable',
  'Min set point': 'Min set point',
  'Max set point': 'Max set point',
  VSD_TARGET: 'VSD Target',
  NEXT_SERVICE_IN: 'next service in',
  NEXT_SERVICE_TYPE: 'next service type',
  h: 'h',
  Min: 'Min',
  WORKING_HOURS: 'working hours',
  HORSE_POWER: 'Horse power',
  RATED_POWER: 'Rated Power',
  RATED_KW: 'Rated kW',
  RATED_HP: 'Rated HP',
  Rated: 'Rated',
  InvertedSpeed: 'Inv Speed',
  'control mode': 'Control Mode',

  'filter type': 'filter type',
  'last service': 'last service',
  CYCLE: 'CYCLE',
  DUTY: 'DUTY',
  'Sensor Based': 'Sensor Based',
  'Compressor Estimation': 'Compressor Estimation',
  'kW Based Calculation': 'kW Based Calculation',
  'AI Calculation': 'AI Calculation',
  'RELATIVE POSITION': 'RELATIVE POSITION',
  'back indication': 'back indication',
  'last command': 'last command',
  'default state': 'default state',
  Open: 'Open',
  'Last set point': 'Last set point',
  'I/O': 'I/O',
  'relative position': 'Relative Position',
  pressureSetpoints: 'Pressure Set Points',
  hp: 'HP',
  lp: 'LP',
  lowLimit: 'Low Limit',
  targetSetpoint: 'Target Setpoint',
  dischargePressure: 'Discharge Pressure',

  // node factory
  Filter: 'Filter',
  Valve: 'Valve',
  INLET_VALVE: 'Inlet valve',
  BYPASS_VALVE: 'Bypass valve',
  OperatingHours: 'Operating Hours',
  CLOSE: 'close',
  OPEN: 'open',
  'Closed Valve - Connected': 'Closed Valve - Connected',
  'Open Valve - Connected': 'Open Valve - Connected',
  'Valve state not found': 'Valve state not found',
  'Valve - Disconnected': 'Valve - Disconnected',
  Booster: 'Booster',
  Compressor: 'Compressor',
  RefDryer: 'Ref. dryer',
  DesDryer: 'Des. dryer',
  General: 'General',
  ProductionFloor: 'Prod.Floor',
  HP: 'HP',
  Pump: 'Pump',
  Vacuum: 'Vacuum',
  Dryer: 'Dryer',

  'Desiccant Air Dryer': 'Desiccant Air Dryer',
  Desiccant: 'Desiccant',
  drying: 'Drying',
  refrigerating: 'Refrigerating',
  waterPressureSensor: 'Water Pressure Sensor',
  'dew point': 'Dew Point',
  DEW_POINT: 'dew point',
  timer: 'Timer',
  energySaving: 'energy saving',
  ENERGY_SAVINGS: 'energy savings',
  'Dew Point Sensor': 'Dew Point Sensor',
  'Dry Air Tank': 'Dry Air Tank',
  Dry: 'Dry',
  'Dry tank': 'Dry tank',
  'Combo Sensor': 'Combo Sensor',
  'Flow Sensor': 'Flow Sensor',
  'Pressure Sensor': 'Pressure Sensor',
  'Production Floor': 'Production Floor',
  'Refrigerated Air Dryer': 'Refrigerated Air Dryer',
  Refrigerated: 'Refrigerated',
  'Wet Air Tank': 'Wet Air Tank',
  Wet: 'Wet',
  Maintenance: 'Maintenance',

  fixedSpeed: 'Fixed Speed',
  variableSpeedDrive: 'Variable Speed',
  centrifugal: 'Centrifugal',
  fixedSpeed_powerSensor: '$t(fixedSpeed)',
  powerSensor_variableSpeedDrive: '$t(variableSpeedDrive)',
  centrifugal_powerSensor: '$t(centrifugal)',
  booster: '$t(Booster)',
  wetAirTank: '$t(Wet Air Tank)',
  dryAirTank: '$t(Dry Air Tank)',
  desiccantAirDryer: '$t(Desiccant Air Dryer)',
  refrigeratedAirDryer: '$t(Refrigerated Air Dryer)',
  pressureSensor: '$t(Pressure Sensor)',
  flowSensor: '$t(Flow Sensor)',
  flowSensor_pressureSensor: 'Flow and Pressure Sensor',
  dewpointSensor: '$t(Dew Point Sensor)',
  dewpointSensor_pressureSensor: 'Dew Point and Pressure Sensor',
  ambientHumiditySensor_ambientTemperatureSensor: 'Ambient Humidity and Temperature Sensor',
  ambientHumiditySensor_ambientTemperatureSensor_dewpointSensor: 'Ambient Humidity, Temperature and Dew Point Sensor',
  airTemperatureSensor: '$t(AIR_TEMPERATURE_SENSOR)',
  airFilter: '$t(Filter)',
  proportionalValve: 'Proportional Valve',
  openCloseValve: 'Open/Close Valve',
  spillValve: 'Spill Valve',
  productionFloor: '$t(Production Floor)',
  pump: '$t(Pump)',
  vacuum: '$t(Vacuum)',

  // alert rules
  'The logic triggering alerts': 'The logic triggering alerts',
  'Alert rules management': 'Alert rules management',
  'My rules': 'My rules',
  'No rules to display': 'No rules to display',
  'Rule condition:': 'Rule condition:',
  and: 'and',
  or: 'or',
  of: 'of',
  is: 'is',
  greaterThan: 'greater than',
  equalTo: 'equal to',
  notEqualTo: 'not equal to',
  greaterThanOrEqualTo: 'greater than or equal to',
  lessThan: 'less than',
  lessThanOrEqualTo: 'less than or equal to',
  'Filter by source': 'Filter by source',
  'Filter by device': 'Filter by device',
  'Create new rule': 'Create new rule',
  'Rule activation status': 'Rule activation status',
  Severity: 'Severity',
  'Date created': 'Date created',
  'Last updated': 'Last updated',
  'Are you sure you want to start monitoring and alerting on this type of events?':
    'Are you sure you want to start monitoring and alerting on this type of events?',
  'Are you sure you want to stop monitoring and alerting on this type of events?':
    'Are you sure you want to stop monitoring and alerting on this type of events?',
  'Failed to change activation status': 'Failed to change activation status',
  'Are you sure you want to delete this rule?': 'Are you sure you want to delete this rule?',
  'Failed to delete rule': 'Failed to delete rule',
  'This alert rule has changed since the record you clicked on. The last change was on':
    'This alert rule has changed since the record you clicked on. The last change was on',
  'This alert rule has been deleted': 'This alert rule has been deleted',
  'You can only turn this alert rule off.': 'You can only turn this alert rule off.',
  'To modify please contact your system administrator or the Ecoplant support':
    'To modify please contact your system administrator or the Ecoplant support',
  'New Alert': 'New Alert',

  // create edit rule
  Update: 'Update',
  Create: 'Create',
  'Create and Activate': 'Create and Activate',
  'Update a custom rule': 'Update a custom rule',
  'Create a custom rule': 'Create a custom rule',
  'Name the alerts and set their severity.': 'Name the alerts and set their severity.',
  'Define the logic for triggering alerts of different severity levels.':
    'Define the logic for triggering alerts of different severity levels.',
  'E.g. High than usual flow causes pressure drop': 'E.g. High than usual flow causes pressure drop',
  Description: 'Description',
  'E.g. Try do the following...': 'E.g. Try do the following...',
  'Alert severity': 'Alert severity',
  'Rule name (Title)': 'Rule name (Title)',
  'Duration (if this rule lasts for x time)': 'Duration (if this rule lasts for x time)',
  Immediately: 'Immediately',
  'Choose the parameter you wish to monitor.': 'Choose the parameter you wish to monitor.',
  Parameter: 'Parameter',
  'Choose a device with the above-selected monitored parameter. Select multiple devices to create a rule on a calculated parameter (e.g. Pressure difference between devices).':
    'Choose a device with the above-selected monitored parameter. Select multiple devices to create a rule on a calculated parameter (e.g. Pressure difference between devices).',
  'Choose the operand and the target value threshold to trigger the alerts.':
    'Choose the operand and the target value threshold to trigger the alerts.',
  Operand: 'Operand',
  'Target value': 'Target value',
  'Save and activate to start monitoring the parameter and trigger alerts according to the rule.':
    'Save and activate to start monitoring the parameter and trigger alerts according to the rule.',
  'Contact us if you have any questions at:': 'Contact us if you have any questions at:',
  'Add device': 'Add device',
  'E.g. 6.4': 'E.g. 6.4',
  'Alert rule updated successfully': 'Alert rule updated successfully',
  'Alert rule created successfully': 'Alert rule created successfully',
  'Follow the math order of operations.': 'Follow the math order of operations.',
  'You dont have enough permission to create an alert, please contact your administrator.':
    'You dont have enough permission to create an alert, please contact your administrator.',
  'Update manufacturer alert rule': 'Update manufacturer alert rule',
  'Edit this Alert rule appearance': 'Edit this Alert rule appearance',
  'Alert rule original details': 'Alert rule original details',
  'Original rule name (Title)': 'Original rule name (Title)',
  'Given rule name (Title)': 'Given rule name (Title)',
  'E.g. High then usual flow causes pressure drop': 'E.g. High then usual flow causes pressure drop',
  'Original description': 'Original description',
  'Given description': 'Given description',
  'Device name': 'Device name',
  'Alert rule ID': 'Alert rule ID',
  'Creation date': 'Creation date',

  //error modal
  'Something went wrong': 'Something went wrong',
  'Please try again later.': 'Please try again later.',
  Dismiss: 'Dismiss',

  //Proactive engine (dynamic controller)
  'Dynamic Controller': 'Dynamic Controller',
  'Controller Mode': 'Controller Mode',
  Activated: 'Activated',
  Deactivated: 'Deactivated',
  Unavailable: 'Unavailable',
  Unknown: 'Unknown',
  'Dynamic Controller is Activated': 'Dynamic Controller is Activated',
  'Dynamic Controller is Deactivated': 'Dynamic Controller is Deactivated',
  'Dynamic Controller is Disabled - Under Maintenance': 'Dynamic Controller is Disabled - Under Maintenance',
  'Dynamic Controller is Disabled by Local Control Switch': 'Dynamic Controller is Disabled by Local Control Switch',
  'Dynamic Controller is Disabled by Cloud Control Switch': 'Dynamic Controller is Disabled by Cloud Control Switch',
  leakMeasurementNear: 'Leak Measurement in a week',
  leakMeasurementOnGoing: 'Leak Measurement is in progress',
  leakMeasurementInDays: 'Leak Measurement scheduled in {{count}} days',
  'Are you sure?': 'Are you sure?',
  FailedToActivateDynamicController: 'Failed to activate dynamic controller',
  FailedToDeactivateDynamicController: 'Failed to deactivate dynamic controller',
  CompressorInMaintenancePreventsActivation:
    'Dynamic Controller cannot be activated due to compressors being in maintenance status or set to priority Ignored',

  // No Flow Control Notification Modal
  noFlowControlNotificationTitle: 'Dynamic Control for this station has been updated.',
  noFlowControlNotificationSubtitle:
    'We\'re now using estimated flow ("no flow") instead of flow-sensor control. As a result:',
  noFlowControlKpisRecalculated: 'Flow and Specific Power KPIs are recalculated, so values may change.',
  noFlowControlSavingsAdjusted: 'Savings are adjusted using the same baseline specific power.',
  noFlowControlSensorsDifferent:
    'Flow sensors still show readings, but they no longer affect KPIs and appear differently on the map.',
  noFlowControlHistoricalKpis: 'Historical flow-sensor KPIs remain available up to the change.',
  noFlowControlClosingMessage: 'This update helps ensure smooth control and consistent performance. Enjoy the update!',
  noFlowControlOkButton: 'OK, Got it!',

  'Last commands': 'Last commands',
  Device: 'Device',
  'New Value': 'New Value',
  User: 'User',
  Status: 'Status',
  Reason: 'Reason',
  'Date Created': 'Date Created',
  'No commands to show': 'No commands to show',
  'Load more': 'Load more',
  'Waiting For Deliver': 'Waiting For Deliver',
  'Received And Updated': 'Received And Updated',
  'Failed To Update': 'Failed To Update',
  'Failed TimeOut': 'Failed TimeOut',
  'Failed Offline': 'Failed Offline',
  'Ignored Unchanged Value': 'Ignored Unchanged Value',

  //Investigation dashboard
  'Investigate by Devices': 'Investigate by Devices',
  'Show me (from-to)': 'Show me (from-to)',
  'Compare with (Show me from-to)': 'Compare with (Show me from-to)',
  'You can choose up to 10 parameters per time period. When comparing 2 time periods, you can choose up to 5 parameters.':
    'You can choose up to 10 parameters per time period. When comparing 2 time periods, you can choose up to 5 parameters.',
  'When comparing 2 time periods, you can choose up to 5 parameters.':
    'When comparing 2 time periods, you can choose up to 5 parameters.',
  'Choose only Power parameters to view the Stack layout. You cannot choose the station total power':
    'Choose only Power parameters to view the Stack layout. You cannot choose the station total power',
  'Station KPIs': 'Station KPIs',
  'Periods compare': 'Periods compare',
  'Pressure drop': 'Pressure Drop',
  'Please choose a time period and at least one parameter.': 'Please choose a time period and at least one parameter.',
  'No data to show for this time frame and parameters.': 'No data to show for this time frame and parameters.',
  'Please choose at least one graph.': 'Please choose at least one graph.',
  'Left mouse to zoom': 'Left mouse to zoom',
  'Alt + Left mouse to pan': 'Alt + Left mouse to pan',
  minuteAverageWithCount: '{{count}} minute average',
  minuteAverageWithCount_plural: '{{count}} minutes average',
  hourAverageWithCount: '{{count}} hour average',
  hourAverageWithCount_plural: '{{count}} hours average',
  'Sensor based': 'Sensor based',
  'Comp. Est.': 'Comp. Est.',
  'kW Calc. Based': 'kW Calc. Based',
  'AI Calc.': 'AI Calc.',
  'kW based calculation': 'kW based calculation',
  Tabular: 'Tabular',
  'Alerts Record List': 'Alerts Record List',
  'Alert Record': 'Alert Record',
  Source: 'Source',
  'Date Fired': 'Date Fired',
  'Displayed alerts': 'Displayed alerts',
  Archived: 'Archived',
  'Time period': 'Time period',
  restAlerts: '...and {{restAlertsCount}} more alerts',
  total: 'Total',
  compareTwoTimePeriods: 'Compare 2 time periods',
  none: 'None',
  showInDeviceStatus: 'Show in device status',
  maintenance: 'Maintenance',
  'n/a': 'N/A',
  devicesStatus: 'Devices Status',
  dynamicControl: 'Dynamic Control',
  optimize: 'OPTIMIZE',
  now: 'Now',

  //Data export
  'Report export': 'Report export',
  'Report export preferences': 'Report export preferences',
  'This file will be downloaded as a .csv': 'This file will be downloaded as a .csv',
  'Time presentation interval': 'Time presentation interval',
  'Time zone': 'Time zone',
  'Unit system': 'Unit system',
  Export: 'Export',
  'Report contains to many records': 'Report contains to many records',
  'Another export is already in progress': 'Another export is already in progress',
  VS: 'VS',
  'Data export failed': 'Data export failed',
  'While your file is being prepared do not refresh or close this tab':
    'While your file is being prepared do not refresh or close this tab',
  'Something went wrong. Make sure you generated a valid report in the investigation tab':
    'Something went wrong. Make sure you generated a valid report in the investigation tab',

  //Station control center
  'Station Control Center': 'Station Control Center',
  TARGET: 'TARGET',
  MAINTENANCE: 'MAINTENANCE',
  OPERATION: 'OPERATION',
  'Failed changing maintenance mode': 'Failed changing maintenance mode',
  SCC: 'SCC',
  'You are about to modify the control of the dynamic controller. Are you sure?':
    'You are about to modify the control of the dynamic controller. Are you sure?',
  setpointsSetTo: 'Setpoints will be set to: ',
  noneSetpoints: 'Last configured Setpoints',
  baselineSetpoints: 'Baseline Setpoints',
  customSetpoints: 'Custom Setpoints',
  contactCustomerSuccessManager: 'Contact your Customer Success Manager to change this behaviour',

  /// Power toggle tooltips
  'Changes can be made in Station Control Center only.': 'Changes can be made in Station Control Center only.',
  'Turn compressor on verification': 'You are about to turn on {{name}}. Are you sure?',
  'Turn compressor off verification': 'You are about to turn off {{name}}. Are you sure?',
  'Function is disabled since Engine Mode is Activated': 'Function is disabled since Engine Mode is Activated',
  'Function is disabled since changing power state is not supported on this compressor.':
    'Function is disabled since changing power state is not supported on this compressor.',
  'Waiting for state to change.': 'Waiting for state to change.',
  'You are not allowed to change power state for devices.': 'You are not allowed to change power state for devices.',
  'Are you sure you want to mark this device as In maintenance?':
    'Are you sure you want to mark this device as In maintenance?',
  'Are you sure you want to mark this device as not in maintenance?':
    'Are you sure you want to mark this device as not in maintenance?',
  goingToMaintenanceMessage: 'Setting all compressors to in maintenance will deactivate dynamic control. Are you sure?',
  CHANGE_COMPRESSOR_STATE_FAILED: 'Failed changing compressor {{deviceName}} power state',
  Start: 'Start',
  Stop: 'Stop',

  //P&ID Draft
  'P&ID Draft': 'P&ID Draft',
  'Last updated on:': 'Last updated on:',
  'Refresh Map': 'Refresh Map',
  'Station Draft': 'Station Draft',

  //Value Dashboard
  SHOWING_CURRENT_MONTH_ACCUMULATED_DATA: 'Showing current month accumulated data',
  Energy: 'Energy',
  Volume: 'Volume',
  'Energy Efficiency': 'Energy Efficiency',
  'Energy Saving': 'Energy Saving',
  Baseline: 'Baseline',
  'Actual Energy': 'Actual Energy',
  'Specific Power Baseline': 'Specific Power Baseline',
  'Maintenance Event': 'Maintenance Event',
  'Baseline Period': 'Baseline Period:',
  To: 'To',
  DAY: 'DAY',
  MTD: 'MTD',
  YTD: 'YTD',
  YEAR: 'YEAR',
  MONTH: 'MONTH',
  AVG: 'AVG',
  MT: 'MT',
  GHG: 'GHG',
  energySavingsOpportunity: 'Energy Savings Opportunity',
  'MONTH AVG': 'MONTH AVG',
  'YEAR TOTAL': 'YEAR TOTAL',
  '5-YEAR PROJECTION REDUCTION': '5-YEAR PROJECTION REDUCTION',
  // Leakage
  leakage: 'Leakage',
  overview: 'Overview',
  segmentation: 'Segmentation',
  timeline: 'Timeline',

  // Overview tab
  lastLeakageMeasure: 'Air Leak estimation relative to {{month}} {{year}}',
  previous: 'Previous',
  lifetime: 'LIFETIME',
  lifeTimeLocalization: 'Lifetime',
  actionTaken: 'Action Taken',
  wasted: 'Wasted',
  lastMeasureDate: 'Last leakage measure',
  nextPeriodicShutdown: 'Next Shutdown',
  add: 'Add',
  setAnAudit: 'Set an Audit',
  dailyFlowTooltip: 'Daily average flow of the previous month',
  kwLeakRateSliderTooltip: 'Estimated power consumption at last periodic shutdown',
  ytdTooltip: 'Data is updated on a monthly basis',
  ok: 'OK',
  clear: 'Clear',
  nextPeriodicShutdownPopconfirm1:
    'A Leak period draft was created. It will be displayed here only after the Ecoplant expert approves it.',
  nextPeriodicShutdownPopconfirm2: 'Compressors must stay on for at least 2 hours to catch leaks.',
  startEnd: 'Start - End',
  leakPeriod: 'Leak Period',
  productionLeakRate: 'Prod Leak Rate',
  addNextPeriodicShutdown: 'Add next leakage period draft',
  confirmDeleting: 'Delete Period Shutdown for periods {{period}}',
  delete: 'Delete',
  excludeFuturePeriodicShutdowns: 'Exclude future shutdown periods',
  leakFlow: 'Measured Leak',
  estimatedLeakTooltip: 'Estimated Leak ({{estimatedLeak}}',
  sampledFlowDuringShutdownTooltip: 'Sampled flow during Shutdown ({{sampledFlowDuringShutdown}}',
  productionLeakRateTooltip:
    'Calculated by normalizing leakage flow to the target pressure then dividing by average production flow ({{productionLeakRate}}',
  overlappingDates: 'Overlapping dates are not valid',
  updateLeakAudit: 'Update Leak Audit',
  updateAudit: 'Update Audit',
  leakAuditUpdatedSuccessfully: 'Leak audit updated successfully',
  theAuditDatesHaveBeenUpdated: 'The audit dates have been updated',
  leakAuditUpdatedAndPublishedSuccessfully: 'Leak draft has been published to the customer',
  errorUpdatingLeakAudit: 'Error updating leak audit',
  leakAuditRejectedSuccessfully: 'Leak audit rejected successfully',
  errorRejectingLeakAudit: 'Error rejecting leak audit',
  leakAuditBookedSuccessfully: 'Leak audit booked successfully',
  scheduleLeakAudit: 'Schedule Leak Audit',
  setAudit: 'Set Audit',
  reviewLeakAudit: 'Review Leak Audit',
  rejectAudit: 'Reject Audit',
  updateAndPublish: 'Update & Publish',
  viewLeak: 'View Leak',
  // MeasurementSegmentation tab
  totalWasteFlow: 'Total Waste Flow',
  totalProductionFlow: 'Total Production Flow',
  productionLine: '{{productionLineName}} Line',
  totalPlant: 'Total Plant',
  production: 'Production',
  waste: 'Waste',
  flowLabel: 'Flow',
  effective: 'Effective',

  // Insights
  insights: 'Insights',
  events: 'Events',
  // Overview tab
  ytdValue: 'YTD VALUE',
  lifetimeValue: 'LIFETIME VALUE',
  savingsOpportunity: 'SAVINGS OPPORTUNITY',
  saved: 'SAVED',
  actionsPending: 'Actions Pending',
  actionsTaken: 'Actions Taken',
  rejected: 'rejected',
  Risk: 'Risk',
  measurementLogTitle: 'The data below refers to the period in which the leak was detected.',
  // Events tab
  pendingTasksOnly: 'Pending Tasks Only',
  dateOpened: 'Date Opened',
  insightName: 'Insight Name',
  asset: 'Asset',
  valueType: 'Value Type',
  value: 'Value {{currency}}',
  dateCompleted: 'Date Completed',
  InProgress: 'In Progress',
  Reject: 'Reject',
  estimatedDeliveredValue: 'Estimated Delivered Value',

  // Engine
  wizard: 'Wizard',
  draft: 'Draft',
  newDraft: 'New Draft',
  createNewDraft: 'Create a New Draft',
  published: 'Published',
  recommended: 'Recommended',
  publishDraftConfirmation: 'Are you sure you want to publish all changes performed on all configuration tabs?',
  publishRecommendationConfirmation:
    'This version will be directly published to production{{draftVersionText}}. Do you want to continue?',
  draftVersionText: ' and override the existing draft version {{draftVersion}}',
  newRecommendedConfiguration: 'A new dynamic controller version is available. Creation date: {{createdDate}}',
  'publishConfirmationEngine1.0':
    'This station is managed by Dynamic Controller version 1.0. To upgrade version 1.5, please go to ReTool and change the Engine version to 1.5. Once this is done, this published version will manage the station.',
  revertToPublishedConfirmation:
    'Are you sure you want to override the configurations with the currently published ones?',
  missingMandatoryFieldValue:
    'Editable field = "{{field}}" of compressor = "{{compressor}}" from table = "{{table}}" requires a valid input.',
  recommendationFlowLevelsChanged:
    'Flow levels or pressure ranges have been modified, therefore the existing fallback rules are invalid and have been removed.',
  revertToPublished: 'Revert to Published',
  publish: 'Publish',
  settings: 'Settings',
  next: 'Next',
  back: 'Back',
  finish: 'Finish',
  cancel: 'Cancel',
  defaults: 'Defaults',
  noDynamicController: 'Dynamic Controller has not been defined.',
  // Recommendation
  createdOn: 'Created on: ',
  approvalReport: 'Approval Report',
  // Rules Generator
  mainRanges: 'Main ranges',
  mainRangesConfiguration: 'Flow And Pressure Configuration',
  rulesGenerator: 'Rules Generator',
  flowLevels: 'FLOW LEVELS',
  'Flow Levels': 'Flow Levels',
  pressureLevels: 'PRESSURE RANGES',
  result: 'RESULT',
  rules: 'Rules',
  // Flow Levels
  units: 'Units',
  name: 'Name',
  lowerBoundFlow: 'Lower Bound Flow',
  upperBoundFlow: 'Upper Bound Flow',
  addRangeName: 'Add range name',
  addUpperRange: 'Add upper range',
  addLevel: 'Add Level',
  addPressureRange: 'Add Pressure Range',
  infinity: 'Infinity',
  flowLevelsChanged:
    'Sensor value ranges are modified, change the table rule values accordingly and save the latest values',
  changesInMainRangesAffectFallbackRules:
    'Changes in the main ranges caused changes in the fallback rules. Are you sure you want to continue?',
  // Pressure Levels
  range: 'Range',
  id: 'Id',
  lowerBoundPressure: 'Lower Bound Pressure',
  upperBoundPressure: 'Upper Bound Pressure',
  thisPressureLevel: 'this pressure level',
  // Result
  mainRangesResult: 'RESULT',
  flowLevel: 'Flow Level',
  rule: 'Rule',
  // Sensors
  sensors: 'Sensors',
  sensorsSelection: 'KPI configuration',
  sensorsConfiguration: 'Sensors Configuration',
  flowSensorsPriority: 'FLOW SENSORS SELECTION',
  pressureSensorsPriority: 'PRESSURE SENSORS SELECTION',
  sensorsPriorityResult: 'RESULT',
  main: 'Main',
  fallback: 'Fallback {{priority}}',
  fallbacks: 'Fallbacks',
  logic: 'Logic',
  online: 'Online',
  any: 'Any',
  all: 'All',
  average: 'Average',
  minimum: 'Minimum',
  maximum: 'Maximum',
  sum: 'Sum',
  addFallback: 'Add Fallback',
  defaultBehaviour: 'Default behaviour',
  chooseRule: 'Choose Rule',
  customRule: 'Custom Rule',
  turnOffEngine: 'Turn off engine',
  ruleGenerator: 'Rule Generator',
  newRuleName: 'NEW RULE NAME',
  // Result
  flowSensorsSelection: 'Flow Sensors Selection',
  pressureSensorsSelection: 'Pressure Sensors Selection',
  // Compressors
  compressors: 'Compressors',
  compressorGroups: 'Compressor groups',
  rotation: 'Rotation',
  on: 'On',
  off: 'Off',
  repeatEvery: 'Repeat every',
  repeatOn: 'Repeat on',
  time: 'Time',
  weeks: 'weeks',
  addCompressorGroup: 'Add a new Compressor Group',
  deletePopconfirmTitle: 'You are about to delete {{item}}. Are you sure?',
  // Default Rule
  defaultRule: 'Default Rule',
  defaultSetpoints: 'Table defaults',
  defaultSetpointsConfiguration: 'Table Defaults',
  groupAndPriority: 'Group | Priority',
  order: 'Order',
  load: 'Load',
  unload: 'Unload',
  autoStop: 'Auto Stop',
  immediateStop: 'Immediate Stop',
  pressureDrop: 'Pressure Drop',
  vsdTarget: 'Target',
  modulate: 'Modulate',
  bandConfiguration: 'Band Configuration',
  defaultSetpointsInfoMessage: 'Setpoints are based on compressor line pressure readings (account pressure drops)',
  setpointsLoadUnloadValidation: 'The Unload setpoint must be higher than the Load setpoint.',
  pidChanges: `A new engine strategy must be defined and published since the station P&ID has changed.
Below is the list of assets  that affect the control strategy:`,
  compressorsAdded: 'Compressors added:',
  compressorsRemoved: 'Compressors removed:',
  flowKPIModified: 'Flow KPI modified:',
  pressureKPIModified: 'Pressure KPI modified:',
  compressorPriorityChangedToIgnore: 'Compressor priority changed from (Active/Backup) to Ignore:',
  compressorPriorityChangedFromIgnore: 'Compressor priority changed from Ignore to (Active/Backup):',

  // Station Parameters
  stationParameters: 'Station Parameters',
  compressorParameters: 'Compressor Parameters',

  //package care
  careAgrremntID: 'Agreement ID',
  annugalHoursCoverage: 'Annual Hours Coverage ',
  startDate: 'Start Date',
  expirationDate: 'Expiration Date',
  packageCare: 'PackageCARE',
  packageCareStatus: 'PackageCARE Status',
  inactive: 'Inactive',
  invalidDate: 'Invalid Date',
  package: 'Package',
  planned: 'Planned',
  parts: 'Parts',
  care: 'CARE',
  careServiceSignUp: 'Sign up to CARE service plan',
  noCareProgram: 'No Care Program',
  thankInterestCare: 'Thank you for your interest in CARE!',
  noCarePlan: 'No CARE Plan',
  activeAsset: 'is activated for this asset',
  tm: 'TM',
  // Fallback Scenarios
  fallbackScenarios: 'FALLBACK SCENARIOS',
  addScenario: 'Add Scenario',
  onFailureOf: 'On failure of',
  singleRuleForAllFlowLevels: 'Single Rule for all Flow Levels',
  logicPerFlowLevel: 'Logic per Flow Level',
  // Validations
  flowRanges: 'Flow Ranges',
  pressureRanges: 'Pressure Ranges',
  rangesAreMandatory: '$t({{ranges}}) are mandatory',
  compressorsAreMandatory: 'Compressors are mandatory',
  higherUpperBound: 'Must be higher than previous Upper Bound',
  mustBeEqualOrHigherThan1: 'Must be equal or greater than 1',
  compressorsCombinationMustBeUnique: 'Compressors combination must be unique',
  compressorIsNotCompatibleToGroup: 'All compressors added to groups must have the same actions',
  compressorsMustHaveSameHp: 'Compressors must have the same HP',
  oneFallbackOptionShouldBeSelected: 'One fallback option should be selected',
  oneRuleShouldBeSelected: 'One rule should be selected',
  sensorsAreMandatory: 'Sensors are mandatory',
  sensorFlowCombinationMustBeUnique: 'Sensor Flow configuration combination must be unique',
  // Rules
  rulesOverview: 'Rules',
  rulesEditor: 'Rules Editor',
  // Rules Overview
  no: 'No',
  ord: 'ORD',
  lo: 'LO',
  un: 'UN',
  target: 'TRG',
  mod: 'MOD',
  aut: 'AUT',
  imm: 'IMM',
  pd: 'PD',
  bnd: 'BND',
  // new fallback columns
  compressorNumber: 'Compressor Number',
  titleOrder: 'ORD',
  titleLoad: 'LO',
  titleUnload: 'UN',
  titleTarget: 'TRG',
  titleModulate: 'MOD',
  titleAutoStop: 'AUT',
  titleImmediateStop: 'IMM',
  titlePressureDrop: 'PD',
  titleBandConfiguration: 'BND',
  // Rules Editor
  standalone: 'Standalone',
  viewMode: 'View Mode',
  editMode: 'Edit Mode',
  save: 'Save',
  discard: 'Yes (discard)',
  keepEditing: 'No (keep editing)',
  // Fallback Overview
  fallbackOverview: 'Fallback',
  sensorsLogic: 'Sensors Logic',
  compressorsGroupOrder: 'Compressors Group Order',
  compressorsFallback: 'Compressors Fallback',
  flowSensorsFallback: 'Flow Sensors Fallback',
  pressureSensorsFallback: 'Pressure Sensors Fallback',
  sensorPriorityInfoMessage: 'In case of a failure, the following logic will be performed',
  editScenarios: 'Edit Scenarios',
  // Version History
  versionHistory: 'Version History',
  lastUpdated: 'Last updated',
  version: 'Version',
  changes: 'Changes',
  revertPublishedVersion:
    'By reverting to the previous version, a new strategy will be published and override the existing draft. Do you want to continue?',
  actions: 'Actions',
  recommendation: 'Recommended',
  algo: 'Algo',
  manual: 'Manual',

  // station risk
  Low: 'Low',
  Moderate: 'Moderate',
  High: 'High',
  SYSTEM_AVAILABILITY: 'system availability',
  REALTIME_SYSTEM_CAPACITY: 'Realtime system capacity',
  'System Health': 'System Health',
  'System Degradation': 'System Degradation',
  'System Single Point of Failure Risk': 'System single point of failure risk',
  'Available flow subtitle': 'Available',
  'Peak production subtitle': 'Peak Production',
  'Month Over Month avg Flow Trend': 'Month over month avg. flow trend',
  'No Active Compressors': 'No Active Compressors',
  'Risk not applicable': 'Risk not applicable',
  'peak production delta increase part1': 'Your month over month compressed air production has increased by ',
  'peak production delta increase part2':
    ' reflecting either growth in production or potential growing leakage in growth',
  'available delta decrease part1': 'Your month over month production capability reflects a declined performance of ',
  'available delta decrease part2': '. Check your compressors for maintenance and degraded operation.',
  'realtime flow over peak error':
    'Error - Realtime value {{realtime}} is above the peak flow {{peakSupplyFlow}}. Please contact Ecoplant support',
  'realtime flow over total flow error': 'Realtime value {{realtime}} is above the total station flow {{totalFlow}}.',
  'realtime flow over max available flow error':
    'Realtime value {{realtime}} is above the max available flow {{totalFlow}}.',
  'Station risk degradation tooltip text':
    'System and per compressor operational degradation from its rated specification',
  'Realtime Production': 'Realtime Production',
  'Peak Production': 'Peak Production',
  PEAK_PRODUCTION: 'peak production',
  'Avg Production': 'Avg Production',
  AVG_PRODUCTION: 'avg production',
  'Max Available': 'Max Available',
  Degradation: 'Degradation',
  MODERATE_RISK: 'moderate risk',
  LOW_RISK: 'low risk',
  STATION_DEGRADATION: 'station degradation',
  PLANNED_AVAILABILITY: 'planned availability',
  CURRENT_YEAR: 'CURRENT YEAR',
  PREVIOUS_YEAR: 'PREVIOUS YEAR',

  // users management
  'Users Management': 'Users Management',
  'Manage Users': 'Manage Users',
  'Create new user': 'Create new user',
  'User must be assigned to at least one station': 'User must be assigned to at least one station',
  'User created successfully': 'User created successfully',
  'User creation failed, please contact support for further information':
    'User creation failed, please contact support for further information',
  'You are about to delete this user completely. Are you sure?':
    'You are about to delete this user completely. Are you sure?',
  'Delete user': 'Delete user',
  'Changes will not be saved. Are you sure?': 'Changes will not be saved. Are you sure?',
  'Discard changes': 'Discard changes',
  'First name': 'First name',
  'Please input your first name': 'Please input your first name',
  'Last name': 'Last name',
  'Please input your last name': 'Please input your last name',
  Email: 'Email',
  'Please input your email': 'Please input your email',
  'Please input a valid email address': 'Please input a valid email address',
  'Measurement system': 'Measurement system',
  'Please choose your measurement system': 'Please choose your measurement system',
  'Dial code': 'Dial code',
  'Please input your dial code': 'Please input your dial code',
  Number: 'Number',
  'Please input your number': 'Please input your number',
  '9 or 10 digits are allowed': '9 or 10 digits are allowed',
  'Only numbers are allowed!': 'Only numbers are allowed!',
  'Please choose a station': 'Please choose a station',
  'Please choose a role': 'Please choose a role',
  'You are about to remove this user’s access to this station. Are you sure?':
    'You are about to remove this user’s access to this station. Are you sure?',
  'E.g. John': 'E.g. John',
  'E.g. Doe': 'E.g. Doe',
  'John@domain.com': 'John@domain.com',
  'Select measurement system': 'Select measurement system',
  '+001': '+001',
  '000000000': '000000000',
  'Select station': 'Select station',
  'Select role': 'Select role',

  // EULA
  'License Agreement': 'License Agreement',
  Decline: 'Decline',
  Accept: 'Accept',

  // Water Temperature
  WATER_TEMPERATURE: 'Water Temperature',
  IN: 'In',
  OUT: 'Out',

  // Metrics
  PRESSURE: 'Pressure',
  FLOW: 'Flow',
  WATER_FLOW: 'Water Flow',
  WATER_PRESSURE_IN: 'Water Pressure In',
  WATER_PRESSURE_OUT: 'Water Pressure Out',
  WATER_PRESSURE_DELTA: 'Water Pressure Delta',
  EST_FLOW: 'est. Flow',
  POWER: 'Power',
  EST_POWER: 'est. Power',
  TEMPERATURE: 'Temperature',
  AIR_TEMPERATURE: 'Air temperature',
  AIR_TEMPERATURE_SENSOR: 'Air Temperature Sensor',
  DEW_POINT_TEMPERATURE: 'Dew point temperature',
  INLET_WATER_TEMPERATURE: 'Inlet Water Temperature',
  OUTLET_WATER_TEMPERATURE: 'Outlet Water Temperature',
  CURRENT: 'Current',
  OIL_TEMPERATURE: 'Oil temperature',
  OIL_TEMPERATURE_CELSIUS: 'Oil Temperature',
  INVERTER_SPEED: 'Inverter speed',
  RUN_HOURS: 'Run hours',
  LOAD_HOURS: 'Load hours',
  HUMIDITY: 'Humidity',
  CONTROL_MODE: 'Control mode',
  MINIMUM_PRESSURE: 'Minimum pressure',
  MAXIMUM_PRESSURE: 'Maximum pressure',
  NEXT_SERVICE_HOURS: 'Next service hours',
  NEXT_SERVICE_NAME: 'Next service name',
  ACTIVITY: 'Activity',
  SPECIFIC_POWER: 'Specific Power',
  EST_SPECIFIC_POWER: 'est. Specific Power',
  EST_INVERTER_SPEED: 'est. Inverter Speed',
  POWERED_ON: 'Powered On',
  INLET_VALVE_OPENING: 'Inlet Valve Opening',
  BYPASS_VALVE_OPENING: 'Bypass Valve Opening',
  CENTRIFUGAL_TARGET_SETPOINT: 'Centrifugal Target Setpoint',
  OPERATION_MODE: 'Operation Mode',
  DRYER_FILTER_SERVICE_HOURS: 'Dryer Filter Service Hours',
  DRYER_DESICCANT_SERVICE_HOURS: 'Dryer Desiccant Service Hours',
  DRYER_VALVE_SERVICE_HOURS: 'Dryer Valve Service Hours',
  DRYER_LEFT_TOWER_ACTIVITY: 'Dryer Left Tower Activity',
  DRYER_RIGHT_TOWER_ACTIVITY: 'Dryer Right Tower Activity',
  DRYER_BLOWER_ACTIVITY: 'Dryer Blower Activity',
  DRYER_HEATER_ACTIVITY: 'Dryer Heater Activity',
  DRYER_TEMPERATURE_SETPOINT_CELSIUS: 'Dryer Temperature Setpoint Celsius',
  DRYER_OPERATION_MODE: 'Dryer Operation Mode',
  DRYER_EXTENDED_ACTIVITY: 'Dryer Extended Activity',
  EXTERIOR_AMBIENT_TEMPERATURE: 'Exterior Ambient Temperature',
  EXTERIOR_AMBIENT_TEMPERATURE_CELSIUS: 'Exterior Ambient Temperature',
  FREQUENCY: 'Frequency',
  P_H: 'PH',
  AMMONIA_AMMONIUM: 'Ammonia (NH3)/Ammonium (NH4+)',
  NITRATE_NO_3: 'Nitrate (NO3-)',
  NITRITE_NO_2: 'Nitrite (NO2-)',
  OXIDATION_REDUCTION_POTENTIAL: 'Oxygen Reduction Potential',
  DISSOLVED_OXYGEN: 'Dissolved Oxygen',
  BLOWER_SPEED: 'Blower Speed',
  BLOWER_TARGET_SPEED: 'Blower Target Speed',
  INFLUENT_FLOW: 'Influent flow',
  SPILL_VALVE_HP_LOW_LIMIT_SETPOINT: 'Spill Valve HP Low Limit Setpoint',
  SPILL_VALVE_HIGH_PRESSURE: 'Spill Valve High Pressure',
  SPILL_VALVE_LOW_PRESSURE: 'Spill Valve Low Pressure',
  SPILL_VALVE_LP_TARGET_SETPOINT: 'Spill Valve LP Target Setpoint',
  CURRENT_VALVE_POSITION: 'Current Valve Position',
  AIR_DISCHARGE_TEMPERATURE: 'Air Discharge Temperature',
  AIR_TEMPERATURE_CELSIUS: 'Air Temperature',
  AIREND_INLET_COOLANT_TEMP_CELSIUS: 'Airend Inlet Coolant Temp',
  AIREND_OUTLET_COOLANT_TEMP_CELSIUS: 'Airend Outlet Coolant Temp',
  AIREND_TEMPERATURE: 'Airend Temperature',
  AUTO_STOP: 'Auto Stop',
  CURRENT_AMP: 'Current',
  DEWPOINT_TEMPERATURE_CELSIUS: 'Dewpoint Temperature',
  DISCHARGE_TEMPERATURE_CELSIUS: 'Discharge Temperature',
  TEMPERATURE_TSE: 'Temperature TSE',
  STAGE_1_TEMPERATURE: 'Stage 1 Temperature',
  STAGE_2_TEMPERATURE: 'Stage 2 Temperature',
  STAGE_3_TEMPERATURE: 'Stage 3 Temperature',
  STAGE_4_TEMPERATURE: 'Stage 4 Temperature',
  STAGE_1_VIBRATION: 'Stage 1 Vibration',
  STAGE_2_VIBRATION: 'Stage 2 Vibration',
  STAGE_3_VIBRATION: 'Stage 3 Vibration',
  STAGE_4_VIBRATION: 'Stage 4 Vibration',
  FREQUENCY_HZ: 'Frequency',
  INLET_AIR_TEMPERATURE_CELSIUS: 'Inlet Air Temperature',
  INTERCOOLER_PRESSURE_BAR: 'Intercooler Pressure',
  INTERNAL_AMBIENT_TEMPERATURE_CELSIUS: 'Internal Ambient Temperature',
  IS_CHECK_VALVE_CLOSED: 'Is Check Valve Closed',
  FIVE_LOOP_PRESSURE_OFFSET_BAR: 'Five Loop Pressure Offset',
  GENERAL_SHUTDOWN: 'General Shutdown',
  HUMIDITY_PERCENTAGE: 'Humidity',
  IMMEDIATE_STOP: 'Immediate Stop',
  INLET_WATER_TEMPERATURE_CELSIUS: 'Inlet Water Temperature',
  INTERIOR_AMBIENT_TEMPERATURE_CELSIUS: 'Interior Ambient Temperature',
  INVERTER_SPEED_RPM: 'Inverter Speed',
  IS_FULL_LOADED: 'Is Full Loaded',
  IS_MAX_LOADED: 'Is Max Loaded',
  IS_MIN_LOADED: 'Is Min Loaded',
  LOCAL_STATION_CONTROL: 'Local Station Control',
  MAXIMUM_PRESSURE_BAND_1: 'Maximum Pressure Band 1',
  MAXIMUM_PRESSURE_BAND_2: 'Maximum Pressure Band 2',
  MINIMUM_PRESSURE_BAND_1: 'Minimum Pressure Band 1',
  MINIMUM_PRESSURE_BAND_2: 'Minimum Pressure Band 2',
  MODULATION: 'Modulation',
  MOTOR_WINDING_TEMPERATURE_CELSIUS: 'Motor Winding Temperature',
  OUTLET_WATER_TEMPERATURE_CELSIUS: 'Outlet Water Temperature',
  PERFORMANCE_LOSS: 'Performance Loss',
  POWER_FACTOR: 'Power Factor',
  POWER_KW: 'Power',
  PRESSURE_BAND: 'Pressure Band',
  PRESSURE_BAR: 'Pressure',
  REMOTE_MODE: 'Remote Mode',
  ROOT_SPEED_RPM: 'Root Speed',
  SPILL_VALVE_HP_LOW_LIMIT_SETPOINT_BAR: 'Spill Valve HP Low Limit Setpoint',
  SPILL_VALVE_HP_PRESSURE_BAR: 'Spill Valve High Pressure',
  SPILL_VALVE_LP_TARGET_SETPOINT_BAR: 'Spill Valve LP Target Setpoint',
  SPILL_VALVE_LP_PRESSURE_BAR: 'Spill Valve Low Pressure',
  SUCTION_PRESSURE: 'Suction Pressure',
  STATION_ON_OFF: 'Station On/Off',
  SURGE_COUNT: 'Surge Count',
  TARGET_PRESSURE_BAND_1_BAR: 'Target Pressure Band 1',
  TARGET_PRESSURE_BAND_2_BAR: 'Target Pressure Band 2',
  TEMPERATURE_CELSIUS_TSE: 'Temperature TSE',
  MIN_PRESSURE: 'Min Pressure',
  MIN_INVERTER_SPEED: 'Min Inverter Speed',
  MAX_INVERTER_SPEED: 'Max Inverter Speed',
  VIBRATION_GEARBOX: 'Vibration Gearbox',
  ROTOR_SPEED: 'Rotor Speed',
  OPERATING_HOURS: 'Operating Hours',
  DISCHARGE_TEMPERATURE: 'Discharge Temperature',
  TARGET_PRESSURE_BAND_1: 'Target Pressure Band 1',
  TARGET_PRESSURE_BAND_2: 'Target Pressure Band 2',
  UNLOAD_TO_OFF_SECONDS: 'Unload To Off Seconds',
  MAX_PRESSURE: 'Max Pressure',
  VSD_TARGET_PRESSURE: 'VSD Target Pressure',

  'Min Inverter Speed': 'Min Inverter Speed',
  'Max Inverter Speed': 'Max Inverter Speed',
  'Performance Loss': 'Performance Loss',
  'Vibration Gearbox': 'Vibration Gearbox',
  'Rotor Speed': 'Rotor Speed',
  'Suction Pressure': 'Suction Pressure',
  'Operating Hours': 'Operating Hours',
  'Discharge Temperature': 'Discharge Temperature',
  'Target Pressure Band 1': 'Target Pressure Band 1',
  'Target Pressure Band 2': 'Target Pressure Band 2',
  'Airend Inlet Coolant Temp': 'Airend Inlet Coolant Temp',
  'Airend Outlet Coolant Temp': 'Airend Outlet Coolant Temp',
  'Inlet Air Temperature': 'Inlet Air Temperature',
  'Airend Temperature': 'Airend Temperature',
  'Temperature TSE': 'Temperature TSE',
  'Minimum Pressure Band 1': 'Minimum Pressure Band 1',
  'Maximum Pressure Band 1': 'Maximum Pressure Band 1',
  'Minimum Pressure Band 2': 'Minimum Pressure Band 2',
  'Maximum Pressure Band 2': 'Maximum Pressure Band 2',
  'Remote Mode': 'Remote Mode',
  'Is Min Loaded': 'Is Min Loaded',
  'Is Max Loaded': 'Is Max Loaded',
  'Is Full Loaded': 'Is Full Loaded',
  'Is Check Valve Closed': 'Is Check Valve Closed',
  'General Shutdown': 'General Shutdown',
  'Five Loop Pressure Offset': 'Five Loop Pressure Offset',
  'Unload To Off Seconds': 'Unload To Off Seconds',
  'Local Station Control': 'Local Station Control',
  'Station On/Off': 'Station On/Off',
  'Pressure Band': 'Pressure Band',
  'Auto Stop': 'Auto Stop',
  'Immediate Stop': 'Immediate Stop',
  Modulation: 'Modulation',
  MaxPressure: 'Max Pressure',

  COMMAND_WAITING_FOR_DELIVER: 'Waiting For Deliver',
  COMMAND_RECEIVED_AND_UPDATED: 'Received And Updated',
  COMMAND_FAILED_TO_UPDATE: 'Failed To Update',
  COMMAND_FAILED_TIME_OUT: 'Failed TimeOut',
  COMMAND_FAILED_OFFLINE: 'Failed Offline',
  COMMAND_IGNORED_UNCHANGED_VALUE: 'Ignored Unchanged Value',

  'Ambient Temperature': 'Ambient Temperature',
  'Ambient Humidity': 'Ambient Humidity',

  'Failed retrieving commands history': 'Failed retrieving commands history',
  alpha: 'Alpha',
  beta: 'Beta',
  powerUsersOnly: 'Power Users only',
  allowCookies: 'Allow cookies',
  decline: 'Decline',

  general: 'General',
  true: 'True',
  false: 'False',
  'Clear all engine configurations': 'Clear all engine configurations',
  'Engine ready': 'Engine ready',
  yes: 'Yes',
  'Are you sure you want to delete all data?': 'Are you sure you want to delete all data?',

  energySavingsReportTitle: 'Ecoplant 360 report',
  energySavingsReportDescription:
    'Below is the Energy savings driven by Ecoplant Dynamic Controller. ' +
    'It is presented in different time resolutions, Previous Day, Month to Date, Year to Date, and ' +
    'Lifetime Savings. It is presented in (1) Percent (%) (and in kWh) (2) in local-currency (3) Estimated Metric Tons ' +
    'of GHG reduction. Savings are calculated based on a comparison to the baseline period and its captured ' +
    'specific power (S/P).',

  insightsReportDescriptionOne:
    'Ecoplant 360 provides its users with ongoing insight driven by either our system or by our experts looking over ' +
    'the system. These insights are divided into three categories Energy, Maintenance and Risk. All insights would have ' +
    'an Action indication either Pending Action or Action Taken. Showing the corresponding estimated USD amount.',
  insightsReportDescriptionTwo:
    'For any Action Pending please click on the corresponding insight for further action required. For any clarification ' +
    'and technical details please contact your customer success manager.',
  insightsReportDescriptionThree: 'Subscription to live insights could be completed on the Ecoplant 360 dashboard',

  leakageReportDescription:
    'Ecoplant 360 provides its users with an overview of estimated leakage. ' +
    'To ensure an update leakage reading, please add on the value dashboard your next expected production shutdown. ' +
    'During the shutdown period and in order to measure leakage, the compressor would be kept running for a couple of ' +
    'hours so the system could measure the consumption by the system’s leaks.',

  openInsightsReportDescriptionOne:
    'Below is a list of all open insights showing both Pending Action items and In Progress items.',
  openInsightsReportDescriptionTwo:
    'For further clarification and analysis please contact your customer success representative.',
  openInsightsReportFooterText: "On Ecoplant 360 value dashboard, you'd be able to explore additional insight details.",

  //LIGHT Project
  enableSystemControl: 'Enable System Control',
  isCalculated: '{{metric}} is calculated.',
  FlowUpper: 'Flow',
  PowerUpper: 'Power',
  toRecord: ' To record your system {{field}} accurately, ',
  performance: 'performance',
  AddNewCompressor: 'Add New Compressor',
  performanceKpisCalculated: 'Performance KPIs are calculated.',
  learnMoreIncreaseSavingsNum: 'Learn more & increase savings with #{{num}} additional system insights',
  learnMoreIncreaseSavings: 'Learn more & increase savings with additional system insights',
  learnMoreRecord: 'Learn more & record your performance accurately',
  clickHere: 'Click Here',
  expandYourStation: 'Expand your station and get a comprehensive overview of all relevant components',
  addCompressor: 'To add a compressor, ',
  Integration: 'Integration',
  externalDeviceId: 'External Id',
  startIntegrationProcess: ' and start the integration process',
  getSensorPackage: ' and get the right sensor package.',
  toRecordPerformance: '  To record your performance accurately, ',
  alwaysPerform: ' and always perform in the optimum operating mode thanks to automatic system control',
  calculatedValues: 'Calculated values',
  learnMoreAndEnableSystemControl: 'Learn More & Enable System Control',
  learnMoreAndEnableKPIs: 'Learn more & Enable KNOW - SYSTEM to get your individual Performance KPIs',
  learnMoreAndEnableLeakage: 'Learn More & Enable Leakage',
  energySavingsSystemTierTooltipPart1:
    'Expected energy-saving opportunities based on real case studies. To always perform in an optimal operation mode and get these savings, ',
  energySavingsSystemTierTooltipPart2: ' and add System Control.',
  requestTierConfirmationMessageLine1: 'A message is sent to Ecoplant.',
  requestTierConfirmationMessageLine2: 'We will contact you right away',
  backgroundDataYearlyView: 'The background data are examples of the yearly energy balance including savings.',
  backgroundDataLeakage: 'The background data are examples of the Leakage widget.',
  additionalSensors: 'Additional Sensors',
  addPressureSensorPack: ' and add a pressure sensor pack to access system pressure conditions and leakage',
  addStationKpis: ' and get your full station KPIs, Click here and enable system view',
  addIndividualSensors: ' and add individual sensors to access your system operation condition',
  system: 'System',
  flowIsCalculated: 'Flow is calculated',
  learnMoreAndEnableSystemHealth: 'Learn More & Enable System Health',
  lockedFunctionality: 'Locked Functionality',
  backgroundDataSystemHealth: 'The background data are examples of the System Health widget.',
  systemView: 'KNOW - SYSTEM',
  systemViewDescription:
    'Unlock a comprehensive supervision of your system performance through an individual P&ID Map, System Trends, System Risk Monitoring and additional system insights to improve your overall system performance and health.',
  learnMoreAndWatchVideo: 'Learn More & Watch Video',
  assetCount: '{{assetCount}} Compressors',
  mon: 'mon',
  perAsset: 'per compressor',
  billedAnnually: 'Billed annually or ',
  monthly: ' monthly',
  expectedAnnualSavings: 'Expected Annual Savings',
  expectedROI: 'Expected ROI',
  years: '< {{years}} Years',
  startOneMonthTrial: 'Start one month trial',
  orPurchaseNow: 'or purchase now',
  allAssetViewFeatures: 'All KNOW - ASSET Features, plus:',
  individual: 'Individual',
  pidMap: 'P&ID Map',
  monitorAndSupervise:
    'to monitor and supervise the performance of your entire system and instantly identify critical components.',
  systemHealthStatus: 'System Health Status',
  isPartOf: 'is part of the Value Dashboard, which monitors your system and production risk level in real-time.',
  systemInsights: 'System insights',
  improveSystemPerformance:
    'on Energy, Maintenance, & Risk improve system performance and health and reduce operating costs.',
  derivedSystemEfficiencyParameters: 'Derived System Efficiency Parameters',
  suchAs: 'such as system pressure, flow, power, and specific power;',
  systemTrends: 'System Trends',
  toAnalyzeAndOptimize: ' to analyze & optimize your system performance based on historical data.',
  backgroundDataMap: 'The background P&ID represents an example of the System Map',
  backgroundData: 'The background data are examples',
  simpleControlDescription:
    'With the simple control engine you improve the overall efficiency and utilization of your system and reduce the runtime of backup and rental compressors. This helps you to considerably reduce energy costs of your system.',
  dynamicControlDescription:
    'Unlock the full dynamic control engine to automatically analyze and adjust operation to production needs for maximum system efficiency. In addition, you can detect and isolate air leaks to even further improve efficiency and reduce your total energy costs to the very minimum.',
  simpleControl: 'CONTROL',
  allSystemViewFeatures: 'All KNOW - SYSTEM Features, plus:',
  simpleControlEngine: 'Simple Control Engine',
  toContinouslyOptimize: 'to continuously optimize the system efficiency and compressor utilization',
  energySavingsWidget: 'Energy Savings Widget',
  toProvideComprehensiveOverview:
    'to provide a comprehensive overview of total energy savings (per day, month, year &amp; total) based on the optimized system efficiency vs. your initial operation',
  greenhouseGasEmission: 'Greenhouse Gas Emission',
  savingsBasedOn: 'savings based on the optimized system efficiency',
  allSimpleControlFeatures: 'All CONTROL Features, plus:',
  dynamicControlEngine: 'Dynamic Control Engine',
  predictiveAlgorithms:
    'Predictive algorithms assess your daily, weekly, and seasonal energy use - dynamically controlling systems via production profiles to minimize energy waste, redundancy, and excess utility costs.',
  leakageWidget: 'Leakage Widget',
  forDetectingAndIsolating:
    'for detecting and isolating the locations of leaks significantly reduces your energy losses.',
  continuousAutiding: 'Continuous Auditing ',
  reviewYourSystemPerformance: 'Review  your system performance and health level',
  getYourPrice: 'Get your price',
  systemControl: 'System Control',
  learnMoreAndRequestTrial: 'LEARN MORE & REQUEST TRIAL',
  ecoplantOffering: 'Ecoplant Offering',
  addOns: 'Add-Ons',
  yourCurrentVersion: 'Your Current Version',
  noStationsAvailable: 'No stations available',
  language: 'Language',
  selectLanguage: 'Select language',
  english: 'English',
  french: 'French',
  spanish: 'Spanish',
  portuguese: 'Portuguese',
  german: 'German',
  Station: 'Station',
  Role: 'Role',
  SMS: 'SMS',
  Insight: 'Insight',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Avg: 'Avg',
  kWh: 'kWh',
  leakMeasurement: 'Leak Measurement',
  valueDashboard: 'Value Dashboard',
  userName: 'User name',
  phoneNumber: 'Phone number',
  'MT GHG': 'MT GHG',
  forMoreThan: 'for more than',
  userAssociatedStations: 'Associated Stations',
  saveChanges: 'Save Changes',
  'Min / Max': 'Min / Max',
  simulationValue: '(Simulation value)',
  actualValue: '(Actual value)',
  Operation: 'Operation',
  Unselect: 'Unselect',
  'Manufacturer and Custom Alerts with Shutdown Severity': 'Manufacturer and Custom Alerts with Shutdown Severity',
  'Manufacturer and Custom Alerts with Warning Severity': 'Manufacturer and Custom Alerts with Warning Severity',
  'Manufacturer and Custom Alerts with Service Severity': 'Manufacturer and Custom Alerts with Service Severity',
  'Notifies on Periodic Shutdown event creation, 1 day before the event':
    'Notifies on Periodic Shutdown event creation, 1 day before the event',
  'Notifies when a new Insight Event is created': 'Notifies when a new Insight Event is created',
  'Notifies when the Dynamic Controller is turned On or Off':
    'Notifies when the Dynamic Controller is turned On or Off',
  "Notifies when a Device's Maintenance flag is changed": "Notifies when a Device's Maintenance flag is changed",
  'Notifies when a Report is generated': 'Notifies when a Report is generated',
  'Notifies when a Station is switched On or Off': 'Notifies when a Station is switched On or Off',
  "couldn't fetch data": "Couldn't fetch data",
  'User update failed': 'User update failed',
  'User deletion failed': 'User deletion failed',
  'User updated successfully': 'User updated successfully',
  'User deleted successfully': 'User deleted successfully',
  Refresh: 'Refresh',
  'Activity Log': 'Activity Log',
  Compressors: 'Compressors',
  'Learn More And Enable Leakage': 'Learn More And Enable Leakage',
  'Background Data Leakage': 'Background Data Leakage',
  'Sign in': 'Sign in',
  OR: 'OR',
  'Login with SSO': 'Login with SSO',
  'is Activated': 'is Activated',
  'is Deactivated': 'is Deactivated',
  'is Disabled - Under Maintenance': 'is Disabled - Under Maintenance',
  'is Disabled by Local Control Switch': 'is Disabled by Local Control Switch',
  'is Disabled by Cloud Control Switch': 'is Disabled by Cloud Control Switch',
  'IN MAINTENANCE': 'IN MAINTENANCE',
  EnergySavings: 'Energy Savings',
  'LIFE TIME SAVINGS': 'LIFE TIME SAVINGS',
  'Unarchive Alert': 'Unarchive Alert',
  'archive alert failed': 'Archive alert failed',
  'Select All': 'Select All',
  'Archive Selected Alerts': 'Archive Selected Alerts',
  'Restore default': 'Restore default',
  'Devices Names': 'Devices Names',
  Close: 'Close',
  Activity: 'Activity',
  'Value may depend on multiple sensors.': 'Value may depend on multiple sensors.',
  Minutes: 'Minutes',
  'kW based Calculation': 'kW based Calculation',
  'Target Setpoint': 'Target Setpoint',
  'PRESSURE SET POINTS': 'PRESSURE SET POINTS',
  'Water Temperature': 'Water Temperature',
  'Set point': 'Set point',
  'DEW POINT': 'DEW POINT',
  'NEXT SERVICE': 'NEXT SERVICE',
  ACTIVTY: 'ACTIVTY',
  'In maintenance': 'In maintenance',
  'Device Details': 'Device Details',
  'This feature is currently disabled.': 'This feature is currently disabled.',
  Revert: 'Revert',
  'Open Insights': 'Open Insights',
  'Sign in without Single Sign On': 'Sign in without Single Sign On',
  'CO2 Reduction': 'CO2 Reduction',
  'Filter by rule': 'Filter by rule',
  Target: 'Target',
  'Compressor Type': 'Compressor Type',
  'Not Connected': 'Not Connected',
  'Keep Alive': 'Keep Alive',
  '9 to 13 digits are allowed': '9 to 13 digits are allowed',
  Notifications: 'Notifications',
  'Station Switch': 'Station Switch',
  'Yearly View': 'Yearly View',
  Jan: 'Jan',
  Feb: 'Feb',
  Mar: 'Mar',
  Apr: 'Apr',
  May: 'May',
  Jun: 'Jun',
  Jul: 'Jul',
  Aug: 'Aug',
  Sep: 'Sep',
  Oct: 'Oct',
  Nov: 'Nov',
  Dec: 'Dec',
  Search: 'Search',
  influentFlow: 'Influent Flow',
  dissolvedOxygen: 'Dissolved Oxygen',
  pH: 'pH',
  ammoniaAmmonium: 'Ammonia (NH3)/Ammonium (NH4+)',
  nitrate: 'Nitrate (NO3-)',
  nitrite: 'Nitrite (NO2-)',
  oxidationReductionPotential: 'Oxidation-Reduction Potential',
  influentFlowSensor: '$t(influentFlow) Sensor',
  dissolvedOxygenSensor: '$t(dissolvedOxygen) Sensor',
  phSensor: '$t(pH) Sensor',
  ammoniaAmmoniumSensor: '$t(ammoniaAmmonium) Sensor',
  nitrateNO3Sensor: '$t(nitrate) Sensor',
  nitriteNO2Sensor: '$t(nitrite) Sensor',
  oxidationReductionPotentialSensor: '$t(oxidationReductionPotential) Sensor',
  'm3/hour': 'm<0>3</0>/hour',
  GPM: 'GPM',
  blowerSpeed: 'Blower Speed % (RPM)',
  frequency: 'Frequency',
  Hz: 'Hz',
  blower: 'Blower',
  aerationBasin: 'Aeration Basin',
  'kWh/MG': 'kWh/MG',

  // Station Parameters Tab
  validationForGreaterThan: '{{title}} must be greater than {{min}} {{unit}}.',
  validationForMinTargetLessThanMaxTarget: 'Min target must be less than max target.',
  validationForMinMax: '{{title}} must be between {{min}} and {{max}} {{unit}}.',
  targetPressure: 'Target Pressure',
  offsetFromTargetPressure: 'Deadband from Target pressure in which to load balance',
  pressureForReloadingCompressor: 'Pressure for Reloading a Compressor',
  pressureForStartingCompressor: 'Pressure for Starting a Compressor',
  pressureForEmergencyStart: 'Pressure for emergency starting a compressor',
  minLoadedCompressors: 'Minimum number of loaded compressors',
  pressureFactor: 'Unload test pressure offset',
  minFrequency: 'Unload attempt delay',
  minPressureSafetyMargin: 'Minimum pressure safety margin',
  minCompressorStartInterval: 'Minimum compressor start interval',
  minCompressorRestartInterval: 'Minimum compressor restart interval',
  flowPeakBuffer: 'Flow peak buffer',
  minIntervalHighFlowTrigger: 'Minimum interval from high flow trigger',
  setpointChangeInterval: 'Unload test offset frequency',
  kpiIntervalRetrieval: 'KPI interval for retrieval',
  loadBalancingPressureFactor: 'Load balancing Pressure Offset',
  emergencyStartFrequency: 'Emergency start frequency',
  bovMin: 'Minimum Average BOV for unload test',
  bovMax: 'BOV threshold to unload from when testing',
  fullLoadPressureBuffer: 'Full load pressure buffer',
  unloadTestingFlowBufferPercentage: 'Unload Testing Flow Buffer Percentage',
  required: 'Required',
  errorSavingEngineConfig: 'Error saving engine configuration. Please try again later.',
  maxTarget: 'Max Target',
  minTarget: 'Min Target',
  priority: 'Priority',
  timeBetweenUnoadingStop: 'Time between unloading and stop (min.)',
  viewReport: 'View Report',
  searchStation: 'Search station',
  'Nothing to update. No changes were made to the information':
    'Nothing to update. No changes were made to the information',
  comments: 'Comments:',
  provideReason: 'Please provide a reason.',
  probabilityofreducingstationpressurebelowminimum: 'Probability of reducing station pressure below min. pressure',
  probabilityofreducingsavingsbelowthecommitment: 'Probability of reducing savings below the commitment',
  probabilityofharmingcompressorshealth: "Probability of harming the compressor's health - select the compressor",
  probabilityofincreasingstationpressure: 'Probability of increasing station pressure',
  edgecasenotproperlycovered: 'Edge cases are not properly covered',
  problematicFlowLevels: 'Problematic Flow Levels',
  problematicPressureRanges: 'Problematic Pressure Ranges',
  compressorRapidCycling: 'Compressor Rapid Cycling',
  problematicSetpointsForCompressor: 'Problematic Setpoints for Compressor',
  probabilityOfStationHighPressureValues: 'Probability of Station High Pressure Values',
  extremeUsecasesAreNotProperlyCovered: 'Extreme usecases are not properly covered',
  refreshEngine: 'If you updated the engine version, refresh to edit parameters',
  centrifugalStation1_0Notification:
    "You're editing Engine 1.5, but Engine 1.0 is active. Changes won't apply until Engine 1.5 is activated in Retool.",
  compressorSetpointsOrderInfo: 'Compressor Setpoints in each table must reflect the assigned order in the OR column.',
  publishConfirmation: 'All configurations across tabs will be published. Confirm to proceed.',
  publishedOn: 'Published on ',
  draftPublishedOn: 'Draft published on ',
  incompleteStationParameters: 'Incomplete Station Parameters',
  incompleteCompressorParameters: 'Incomplete Compressor Parameters',
  compressorParametersMissing: 'Some of the compressor parameters are missing.',
  stationParametersMissing: 'Some of the station parameters are missing.',
  errorSavingDraft: 'Error saving draft.',
  errorSavingDraftdesc: 'Please fill all the required fields for both station and compressors.',
  success: 'success',
  error: 'error',
  draftSaved: 'Draft saved successfully.',
  draftSavedDesc: 'Your changes are saved. Remember to publish when ready.',
  errorSavingChanges: 'There was an error saving your changes.',
  errorRevertLastPublished: 'Error Reverting to Last Published',
  errorRevertLastPublishedDesc: 'There was an error reverting to the last published version.',
  successPublish: 'Changes Published Successfully',
  successPublishDesc: 'Dynamic controller is now running with the published parameters.',
  errorDraftPublish: 'Error Publishing Draft',
  errorDraftPublishDesc: 'There was an error publishing your changes.',
  publishChanges: 'Publish Changes',
  revertToLastPublished: 'Revert to Last Published',
  confirmPublish: 'Confirm Publishing Changes',
  publishChange: 'Publish Change',
  reviewAgain: 'Review Again',
  advancedSettings: 'Advanced Settings',
  stopDelayMinutes: 'Stop Delay minutes',
  maxFlow: 'Max Flow',
  maxLoadAmps: 'Max Load Amps',
  fiveLoop: '5 Loop',
  noBaseline: 'No Baseline',
  noDefaultBaselineStrategy: 'No default baseline strategy available at this moment',
  revertToDefaultBaselineStrategy:
    'Are you sure you want to override the existing draft with the default baseline configurations?',

  // Station Stages
  stationStageUpdating: 'Updating stage...',
  stationStageUpdated: 'Stage updated successfully.',
  stationStageError: 'Failed to update stage. Please try again.',
  stationStageNoStageSelected: 'No stage selected',
  stationStageState: 'State',
  stationStageMoveTo: 'Move to',
  stationStageStatus: 'Station Status',
  stationStageDeprecateTitle: 'Deprecate Station',
  stationStageDeprecateWarning: 'You are about to move this station to a deprecated status. This action will:',
  stationStageDeprecateConsequences1: 'Disable all system controls for the station.',
  stationStageDeprecateConsequences2: 'Prevent further data collection and updates.',
  stationStageDeprecateConsequences3: 'Archive the station for historical reference.',
  stationStageDeprecateConfirm: 'Are you sure you want to proceed? This action cannot be undone.',
  stationStageDeprecateButton: 'Deprecate Station',
  stationStageCancelButton: 'Cancel',
  //installtion validation tab
  INSTALLATION_VALIDATION_TITLE: 'Installation Validation',
  INSTALLATION_VALIDATION_SUBMITTED_TITLE: 'Validation already submitted',
  INSTALLATION_VALIDATION_SUBMITTED_CONTENT:
    'Another user has already submitted this validation. Please refresh to see the current status.',
  INSTALLATION_VALIDATION_IN_PROGRESS_TITLE: 'Validation in progress',
  INSTALLATION_VALIDATION_IN_PROGRESS_CONTENT:
    'Another user has already started this validation. Please refresh to see the current status.',
  NOT_AVAILABLE: 'N/A',
  TESTING_IN_PROGRESS: 'Testing in progress {{time}}',
  UNRESOLVED_COMPRESSORS_TITLE: 'Unresolved Compressor States',
  UNRESOLVED_COMPRESSORS_DESC:
    '{{count}} compressors did not pass the test. Please provide a comment or reason for each before submitting the report',
  TEST_SUCCESS_TITLE: 'Test completed successfully',
  TEST_SUCCESS_DESC: 'All the compressors states has successfully passed the test.',
  REPORT_SUBMIT_SUCCESS: 'Report submitted successfully',
  REPORT_SUBMIT_ERROR: 'Failed to submit report',
  TEST_NOT_INITIATED_TITLE: 'Test was not initiated properly',
  TEST_NOT_INITIATED_DESC: 'Test was not initiated properly, Please start the test again.',
  LOAD_TEST: 'Load test',
  DEVICE_STATUS_LOAD: 'Device in status Load',
  DEVICE_STATUS_UNLOAD: 'Device in status Unload',
  ESTIMATED_FLOW: 'Estimated flow',
  SENSOR_READING: 'Sensor reading',
  Differences: 'Differences',
  Diff: 'Diff',
  UNLOAD_TEST: 'Unload test',
  PASSED: 'Passed',
  FAILED: 'Failed',
  EXPECTED_VALUE_READING_VALUE: 'Expected:{{expectedValue}}kW - Reading: {{readingValue}}kW ',
  TESTING: 'Testing',
  NOT_TESTED: 'Not tested',
  INIT_SCENARIO: 'Init scenario',
  NOT_INCLUDE_SENSOR: 'Not include sensor',
  NOT_STARTED: '',
  VIEW_COMMENT: 'View comment',
  ADD_COMMENT: 'Add comment',
  NO_POWER_SENSOR: 'No power sensor',
  UNRESOLVED_COMPRESSORS_MESSAGE:
    'compressors did not pass the test. Please provide a comment or reason for each before submitting the report',
  SUBMIT_CONFIRMATION_MESSAGE:
    'By submitting the test report, you indicate the installation is complete and ready for review',
  BACK_TO_LIST: 'Back to list',
  TEST_AGAIN: 'Test again',
  SUBMIT_REPORT: 'Submit report',
  CANCEL: 'Cancel',
  'Flow sum': 'Flow sum ',
  unresolvedCompressorStates: 'Unresolved Compressor States',
  confirmSubmission: 'Confirm submission',
  testCompletedSuccessfully: 'Test completed successfully',
  commentsInfo: 'Comments will only be saved in the submitted report.',
  comment: 'Comment',
  loadTestFailed: 'Load test failed',
  unloadTestFailed: 'Unload test failed',
  loadTestNotTested: 'Load test not performed',
  unloadTestNotTested: 'Unload test not performed',
  okCamelCase: 'Ok',
  flowTestFailed: 'Flow test failed',
  flowTestNotTested: 'Flow test not performed',
  START_TEST: 'Start Test',
  CANCEL_TEST: 'Cancel Test',
  continue_test: 'Continue Test',
  cancel_validation_test: 'Cancel Validation Test?',
  cancel_button_content:
    'You are about to cancel the installation validation process. All collected data will be discarded and not saved. Are you sure you want to cancel it?',
  END_TEST: 'End test',
  TEST_DATE: 'Test date: {{date}}',
  TEST_DATE_WITHOUT_FIELD: 'Test date:',
  TESTED_BY: 'Tested by:',
  SAVE_CHANGES: 'Save changes',
  ADD: 'Add',
  compressorMetrics: 'Compressor Metrics',
  noMetricsAvailable: 'No metrics available',
  loadBand1: 'Load Band 1',
  loadBand2: 'Load Band 2',
  unloadBand1: 'Unload Band 1',
  unloadBand2: 'Unload Band 2',
  sensorsKPIConfiguration: 'Sensors KPI Configuration',
  flowSensorKPI: 'Flow sensor KPI',
  pressureSensorKPI: 'Pressure sensor KPI',
  moreActions: 'More Actions',
  StationStatus_Inactive: 'Dynamic Controller is Inactive',
  StationStatus_oneDotZeroActive: 'Dynamic Controller 1.0 is Activated',
  StationStatus_oneDotFiveActive: 'Dynamic Controller 1.5 is Activated',
  StationStatus_oneDotZeroUnderMaintenance: 'Dynamic Controller 1.0 is Disabled - Under Maintenance',
  StationStatus_oneDotFiveUnderMaintenance: 'Dynamic Controller 1.5 is Disabled - Under Maintenance',
  StationStatus_oneDotFiveActiveFallback: 'Dynamic Controller 1.5 is Activated',
  StationStatus_oneDotZeroDisabled: 'Dynamic Controller 1.0 is Disabled',
  StationStatus_oneDotFiveDisabled: 'Dynamic Controller 1.5 is Disabled',
  StationStatus_notControlled: 'Not Controlled',
  StationStatus_offline: 'Offline',
  theme: 'Theme',
  dark: 'Dark',
  light: 'Light',
  measurementSystem: 'Measurement unit',
  versionRevertedSuccess: 'Version successfully reverted',
  languageUpdateSuccess: 'Language updated successfully',
  languageUpdateFailed: 'Language update failed',
  en: 'English',
  fr: 'French',
  es: 'Spanish',
  pt: 'Portuguese',
  de: 'German',
  metric: 'Metric',
  imperial: 'Imperial',
  SelectReason: 'Select a reason',
  missingSpec: 'Missing data',
  revertConfirmation:
    'You request to override the existing strategy with version {{version}}. By reverting to this version, a new strategy will be published and override the existing draft. Do you want to continue?',
  versionRevertError: 'Error reverting version',

  // EPTable controls
  scrollToTop: 'Scroll to top',
  scrollToBottom: 'Scroll to bottom',
  showAllRows: 'Show all rows',
  showWithPagination: 'Show with pagination',
  showLess: 'Show Less',
  showAll: 'Show All',
  reason: 'Reason',
  dateTime: 'Date & Time:',
  deactivatedBy: 'Deactivated By:',
  deactivationReason: 'Deactivation Reason',
  viewReason: 'View Reason',
  confirmDeactivationTitle: 'Confirm Deactivation & Provide Reason',
  confirmDeactivationButtonText: 'Confirm Deactivation',
  deactivationContent:
    'Deactivating the dynamic controller may impact system operations. Please confirm and share the reason for deactivation',
  stopDelayMinutesEmptyMessage: 'Stop Delay Minutes should not be empty',
  priorityEmptyMessage: 'Priority should not be empty',
  priorityUniqueValueMessage: 'Each compressor must have a unique priority value',
  shouldNotBeEmpty: 'should not be empty',
  maxTargetGreaterThanMinTarget: 'Max Target should be greater than Min Target',
  minTargetLessThanMaxTarget: 'Min Target should be less than Max Target',
  //Site survey form
  welcomeTitle: 'Welcome to the site survey',
  welcomeSteps: 'Start by adding the Salesforce account ID then follow these 3 simple steps',
  accountPlaceholder: 'Add Salesforce account ID',
  accountRequired: 'Please input Salesforce account ID',
  accountTooltip: 'Add the ID_18 from Salesforce',
  startButton: 'Lets go',
  confirmCustomerDetails: 'Confirm customer details',
  tierRequired: 'Please select a tier',
  selectTier: 'Select tier',
  siteAddress: 'Site address',
  selectFormStation: 'Select station',
  availableSitesForm: 'Available site surveys',
  notSelectedPressureType: 'Pressure type not yet selected',
  MainPressure: 'Main',
  continueEditingForm: 'Continue editing',
  canContinueEditing:
    'You can continue editing it or start a new one. Starting a new survey will replace the existing one and cannot be undone.',
  contactPerson: 'Contact person',
  edit: 'Edit',
  reviewAndPublish: 'Review & Publish',
  saveExitSiteSurvey: 'Save & Exit the site survey?',
  siteFormAlreadyExists: ' A site survey already exists for this account',
  closeModalBody:
    'Your progress has been saved. You can continue editing this station anytime from the station list on the main screen.',
  stayAndContinue: 'Stay & Continue',
  saveAndExit: 'Save & Exit',
  discardAndExit: 'Discard & Exit',
  startNewSurvey: 'Start new survey',
  associateWithCustomer: 'Associate with Ecoplant customer (optional)',
  allocateStationDescription: 'Want to allocate this station to an existing Ecoplant account?',
  selectAccount: 'Select account',
  continue: 'Continue',
  'Salesforce account ID': 'Salesforce account ID',
  Monitor: 'Monitor',
  Optimize: 'Optimize',
  'Edit site address': 'Edit site address',
  'This address will be used for the shipment of equipment': 'This address will be used for the shipment of equipment',
  'Street address': 'Street address',
  City: 'City',
  State: 'State',
  Country: 'Country',
  'ZIP code': 'ZIP code',
  'Please enter street address': 'Please enter street address',
  'Please enter city': 'Please enter city',
  'Please enter state': 'Please enter state',
  'Please enter ZIP code': 'Please enter ZIP code',
  'Please enter a valid ZIP Code': 'Please enter a valid ZIP Code',
  'Save changes': 'Save changes',
  'Edit contact person': 'Edit contact person',
  'Full name': 'Full name',
  'Please enter full name': 'Please enter full name',
  'Please enter email': 'Please enter email',
  'Please enter a valid email address': 'Please enter a valid email address',
  'Please select a tier': 'Please select a tier',
  'No accounts available': 'No accounts available',
  'Welcome to the site survey': 'Welcome to the site survey',
  'Easily configure a precise, customer-specific site map.': 'Easily configure a precise, customer-specific site map.',
  'Start by adding the Salesforce account ID then follow these 3 simple steps':
    'Start by adding the Salesforce account ID then follow these 3 simple steps',
  'Add Salesforce account ID': 'Add Salesforce account ID',
  'Failed to fetch account data. Please try again.': 'Failed to fetch account data. Please try again.',
  'Cannot proceed: Missing Salesforce Account ID': 'Cannot proceed: Missing Salesforce Account ID',
  'Site configuration data may not be properly saved': 'Site configuration data may not be properly saved',
  'Failed to fetch model specifications. Some dropdown options may not be available.':
    'Failed to fetch model specifications. Some dropdown options may not be available.',
  'Assets assignment data may not be properly saved': 'Assets assignment data may not be properly saved',
  'Assets assignment data saved successfully': 'Assets assignment data saved successfully',
  'Failed to save assets assignment data. Please try again.':
    'Failed to save assets assignment data. Please try again.',
  customerInformationStepLabel: 'Confirm customer info',
  siteConfigurationStepLabel: 'Define Site configuration',
  roomConfigurationStepLabel: 'Assign assets',
  backButton: 'Back',
  closeButton: 'Close',
  Continue: 'Continue',
  'Create Station': 'Create Station',
  'Please fix validation errors before submitting': 'Please fix validation errors before submitting',
  'Define site configuration': 'Define site configuration',
  'Number of compressor rooms': 'Number of compressor rooms',
  Other: 'Other',
  'Number of production floors': 'Number of production floors',
  'System controller type (If installed)': 'System controller type (If installed)',
  'Add system controller type': 'Add system controller type',
  "Station's name": "Station's name",
  'Is there more than 1 target pressure?': 'Is there more than 1 target pressure?',
  'What is the pressure at this station?': 'What is the pressure at this station?',
  'Note: Each pressure type requires a separate site survey':
    'Note: Each pressure type requires a separate site survey',
  'Assets assignment': 'Assets assignment',
  Remove: 'Remove',
  'Compressors in this room': 'Compressors in this room',
  'Select available compressors': 'Select available compressors',
  'Add manual compressor': 'Add manual compressor',
  'This number is already in use': 'This number is already in use',
  'Serial number': 'Serial number',
  Model: 'Model',
  'Model spec': 'Model spec',
  Select: 'Select',
  Controller: 'Controller',
  'Delete compressor': 'Delete compressor',
  'Add details for accurate setup': 'Add details for accurate setup',
  'Tanks in the room': 'Tanks in the room',
  'Select Type': 'Select Type',
  'Add another tank': 'Add another tank',
  'Add room': 'Add room',
  'Define Site Configuration': 'Define Site Configuration',
  'Each compressor must have a unique number': 'Each compressor must have a unique number',
  'Each room must have at least one compressor': 'Each room must have at least one compressor',
  compressorRooms: 'Compressor Rooms',
  pressureType: 'Pressure Type',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  'Assets Assignment': 'Assets Assignment',
  'Compressor number is required': 'Compressor number is required',
  createNewSite: 'Create or Edit Site Survey',
  welcomeDescription:
    'Configure a precise, customer-specific site map. Enter the Salesforce account ID to start a new survey or continue an existing one.',
  lit: 'Lit',
  'Please enter a valid ZIP code': 'Please enter a valid ZIP code',
  'Please enter only numbers': 'Please enter only numbers',
  'Progress saved successfully.': 'Progress saved successfully.',
  'Failed to save progress. Please try again.': 'Failed to save progress. Please try again.',

  measuredLeak: 'Measured',
  leakMeasureFlow: '% Flow',
  leakProductionFlow: '% prod. flow',

  leakageCreatedNotificationMessage: 'Notifies when a new Leakage Event is created',
  addStation: 'Add Station',
  activateDynamicControllerMessage: 'Are you sure you want to activate the dynamic controller?',
  activate: 'Activate',
  activateDynamicController: 'Activate Dynamic Controller',
  'Dryers in the room': 'Dryers in the room',
  'Add another dryer': 'Add another dryer',
  systemcare: 'System',
  packagecare: 'Package',
  plannedcare: 'Planned',
  partscare: 'Parts',
  nocareprogram: 'No Package',
  packageCareTooltip: 'ID: {{careAgreementId}} • Ends: {{endDate}}',
  remoteControlSupported: 'Control Supported',
  remoteControlUnsupported: 'Control Unsupported',
  compressor: 'Compressor',
  assetInfo: 'Asset info',
  advancedInfo: 'Advanced info',
  assetImages: 'Asset images',
  serialNumber: 'Serial number',
  model: 'Model',
  platform: 'Platform',
  coolingType: 'Cooling type',
  compressorType: 'Compressor type',
  oilFlooded: 'Oil flooded',
  stageDryScrew: 'Stage dry screw',
  reciprocating: 'Reciprocating',
  airCooled: 'Air cooled',
  waterCooled: 'Water cooled',
  maxPressure: 'Max Pressure',
  realTimeData: 'Real-time data',
  serviceInformation: 'Service information',
  serviceDueIn: 'Service Due in {{hours}}h',
  workingHours: 'Working hours',
  run: 'Run',
  hoursToService: 'Hours to service',
  serviceType: 'Service type',
  bookAService: 'Book a service',
  alert: 'Alert',
  inletValve: 'Inlet valve',
  bypassValve: 'Bypass valve',
  modelAttributes: 'Model Attributes',
  modelSpecs: 'Model Specs',
  metrics: 'Metrics',
  deviceAttributes: 'Device Attributes',
  noAlertsAtTheMoment: 'No alerts at the moment',
  viewPastAlerts: 'View past alerts in the Archive tab.',
  stationControlDefaultSetpointsBaseline:
    'You are about to deactivate the dynamic controller. The station will be reverted to baseline setpoints. Please confirm and share the reason for deactivation',
  stationControlDefaultSetpointsCustom:
    'You are about to deactivate the dynamic controller. The station will be reverted to custom setpoints. Please confirm and share the reason for deactivation',
  siteSurveyRemoveCompressor: 'Remove compressor',
  uploadImageTitle: 'Add photos for this compressor',
  uploadImageStepHelperText: 'Upload clear photos to help us document this compressor properly.',
  uploadImageTaggingTitle: 'Tag what each photo shows',
  uploadImageTagMachineDataTag: 'Machine Data Tag',
  uploadImageTagControllerFront: 'Controller Front',
  uploadImageTagControllerBack: 'Controller Back',
  uploadImageTagElectricalCabinet: 'Electrical Cabinet',
  uploadImageTagIncomingWiring: 'Incoming Wiring',
  uploadImageTagOther: 'Other',
  uploadImageMobileSelectHelperText:
    'Snap or upload clear photos to help us document this compressor properly. Try to include pictures of:',
  uploadImageTakePictureButtonText: 'Take A Picture',
  uploadImageFromGalleryButtonText: 'Upload from gallery',
  uploadImageUnifiedButtonText: 'Add pictures',
  uploadImageUnifiedButtonAddAnotherText: 'Add another photo',
  uploadImageMobilePreviewHelperText: 'Pictures to include',
  uploadImageMobilePreviewContinueButtonText: 'Continue to picture tagging',
  uploadImageTagsDrawerTitle: 'Try to include the following:',
  uploadImageRules: 'Upload up to {{limit}} {{maxSize}}MB files (JPEG, JPG, PNG, HEIF, HEIC)',
  uploadImageComputerHelperText: 'Click or drag file to this area to upload',
  uploadImageFileLimitErrorMessage: 'You can upload up to {{limit}} images only',
  uploadImagePopoverTitle: 'Add pictures to this compressor',
  uploadImageMaxSizeError: '{{filename}} size exceeds the limit of {{maxSize}}MB',
  uploadImageError: 'Could not upload file {{filename}}. Please try again.',
  imageUploadFailedMessage: "Some pictures couldn't be saved",
  imageUploadFailedMessageDescription:
    '{{failedCount}} out of {{totalCount}} pictures could not be saved. You can review and re-add them if needed',
  uploadImageEditButtonText: 'Change tag',
  uploadImageEditSaveButtonText: 'Save changes',
  uploadImageBackToUpload: 'Back to upload',
  uploadImageImageTaggingHelperText:
    'Click on the appropriate tag to apply it to the image. Please note that every image must be tagged',
  uploadImageTaggingError: 'Please tag all images before continuing',
  uploadImageOpenWizzardButton: 'Upload images',
  uploadImageDownloadError: 'Failed to download image {{filename}}.',
  'Spec data': 'Spec data',
  Edit: 'Edit',
  Platform: 'Platform',
  'Cooling type': 'Cooling type',
  'URL to compressor model spec': 'URL to compressor model spec',
  'Add information for setup of': 'Add information for setup of',
  'Enter value': 'Enter value',
  Horsepower: 'Horsepower',
  RatedPower: 'Rated Power',
  Cooling: 'Cooling',
  Type: 'Type',
  'Have a spec URL instead?': 'Have a spec URL instead?',
  'Add spec link instead': 'Add spec link instead',
  'Paste link to spec': 'Paste link to spec',
  "Don't have a URL?": "Don't have a URL?",
  'Enter details manually': 'Enter details manually',
  'Select manufacturer': 'Select manufacturer',
  'Additional compressors': 'Additional compressors',
  'Please enter a valid URL': 'Please enter a valid URL',
  'Full Name': 'Full Name',
  'Edit Account Manager': 'Edit Account Manager',
  packagecarepmonly: 'PM Only',
  cycle: 'Cycle',
  active: 'Active',
  disabled: 'Disabled',
  activeFallback: 'Active (Fallback)',
  engineStatusNotAvailable: 'Engine Status overlay is not available when comparing periods',
  addEngineStatusOverlay: 'Add Engine Status Overlay',
  engineStatus: 'Engine Status',
  unavailable: 'Unavailable',
  notActive: 'Not Active',
  compatible: 'Compatible',
  notCompatible: 'Not Compatible',
  optOut: 'Opt Out',
  userUnitOfMeasure: 'User unit of measure',
  moveToMaintenance: 'Move to maintenance',
  confirmStop: 'Confirm Stop',
  confirmStopDescription: 'You are about to stop this compressor. Confirm to proceed.',
  STOP: 'STOP',
  START: 'START',
  Stopping: 'Stopping...',
  Starting: 'Starting...',
  'Water Temperature In': 'Water Temperature In',
  'Water Temperature Out': 'Water Temperature Out',
  'Units are in bar, do you want to continue?': 'Units are in bar, do you want to continue?',
  'Drive Type': 'Drive Type',
  uploadPictures: 'Upload pictures',
  picturesAvailableCount: '{{count}} pictures available',
  deleteImage: 'Are you sure you want to delete this image? This action is irreversible.',
  // Engine Validation Modal
  engineValidationTitle: 'Engine Status Validation',
  engineValidationMessage:
    'You cannot move the station from Subscription state as long as the engine status is active. Please make sure to deactivate the engine before moving the station state.',
  // cause of rejection of Algo recommendation
  flowlevels: 'Flow levels',
  pressureranges: 'Pressure ranges',
  wrongcompressorcombinations: 'Wrong compressor combination - Select Table',
  pressuredrop: 'Pressure drop - Select Table',
  setpointsforcompressor: 'Setpoints for compressor - select compressor + select table',
  fallbackcoverage: 'Fallback coverage',
  possiblecause: 'Possible Cause:',
  selecttables: 'Select Tables',
  selectReasonError: 'Please select a reason for rejection',
  selectCauseError: 'Please select a possible cause for rejection',
  selectCompressorError: 'Please select at least one compressor for the reason',
  selectCompressorCauseError: 'Please select at least one compressor for the possible cause',
  selectTableError: 'Please select at least one table',
  commentLengthError: 'Comment must be between 2 and 200 characters',
  causeCommentLengthError: 'Possible cause comment must be between 2 and 200 characters',
  uploadImageTagPipeFocused: 'Pipe (Focused)',
  uploadImageTagPipePanoramaVideo: 'Pipe (Panorama/Video)',
  uploadImageTagSensor: 'Sensor',
  // Lifecycle page
  'Time left to complete': 'Time left to complete',
  'Time to complete': 'Time to complete',
  Overdue: 'Overdue',
  Completed: 'Completed',
  Lifecycle: 'Lifecycle',
  Opportunity: 'Opportunity',
  Design: 'Design',
  Staging: 'Staging',
  Installation: 'Installation',
  Validation: 'Validation',
  ControlPrep: 'Control prep',
  Subscription: 'Subscription',
  Deprecated: 'Deprecated',
  New: 'New',
  OrderPlacement: 'Order Placement',
  SubscriptionNoControl: 'Subscription No Control',
  'Move to': 'Move to',
  Skip: 'Skip',
  'Skip staging and move to installation': 'Skip staging and move to installation',
  'Station tracker': 'Station tracker',
  'Link to presentation': 'Link to presentation',
  'Block stage': 'Block stage',
  'Unblock stage': 'Unblock stage',
  Unblock: 'Unblock',
  'order-purchase-number': 'Order purchase number',
  'po-start-date': 'PO Date',
  'kickoff-meeting-date': 'Internal Kickoff meeting date',
  'meeting-presentation': 'Meeting summary',
  'contract-number': 'Contract number',
  'assign-cs-owner': 'Customer success owner',
  'assign-engine-owner': 'Engine owner',
  'optimize-not-controlled-station': 'Station Control Type',
  'optimize-not-controlled-station-subtitle': 'Set control method for this station',
  'station-as-built': 'Station As Built',
  'kw-cost': 'Kw Cost',
  'air-expert-approval': 'Air expert approval',
  'approve-pid': 'Approve PID',
  'link-bom-document': 'Station BOM',
  'parts-order-number': 'Parts order number',
  'parts-tracking': 'Parts tracking number',
  'parts-arrived-date': 'Parts arrival estimation',
  'staging-ready': 'Staging ready',
  'planned-installation-date': 'Planned installation date',
  'installation-approval-report': 'Installation approval report',
  'compressor-control-test-executed': 'Compressor control test executed',
  'installation-images-taken': 'Installation images taken',
  'installation-dates': 'Installation dates',
  'installation-validation-date': 'Installation validation date',
  'baseline-period': 'Baseline period',
  'baseline-report': 'Baseline report',
  'training-meeting-date': 'Customer training session',
  'training-session-summary': 'Training session summary',
  'engine-activation-date': 'Engine activation date',
  'engine-creation-date': 'Engine creation date',
  'min-pressure': 'Min pressure',
  'air-expert-installation-approval': 'Air expert installation approval',
  'kpi-ranges-validation': 'KPI ranges validation',
  'average-specific-power': 'Average specific power',
  'engine-version': 'Engine version',
  'savings-commitment': 'Savings commitment',
  'Add a link to document': 'Add a link to document',
  'Add a link to presentation': 'Add a link to presentation',
  'Add a link to report': 'Add a link to report',
  'Add link to SCC activity log screenshot': 'Add link to SCC activity log screenshot',
  'More than one tracking number can be added.': 'More than one tracking number can be added.',
  'More than one order number can be added.': 'More than one order number can be added.',
  'Please add a link': 'Please add a link',
  'Please add a valid link': 'Please add a valid link',
  blockStageModalTitle: 'Why are you blocking this stage?',
  blockStageModalDescription: 'Help the team understand what’s holding things back so we can act on it quickly.',
  blockStageModalReason: 'Reason for blocking',
  'Save reason': 'Save reason',
  'Stage blocked successfully': 'Stage blocked successfully',
  'Failed to block stage': 'Failed to block stage',
  'Blocked from': 'Blocked from',
  dayChar: 'd',
  'Saving...': 'Saving...',
  'Required to complete stage': 'Required to complete stage',
  'Failed to save, your changes will be lost': 'Failed to save, your changes will be lost',
  'Failed to save': 'Failed to save',
  'Valid values': 'Valid values',
  'Missing PO#': 'Missing PO#',
  'Missing Contract#': 'Missing Contract#',
  'No Internal Kickoff Date': 'No Internal Kickoff Date',
  'Controllers Missing': 'Controllers Missing',
  'Compressor Info': 'Compressor Info',
  'Complex Pipes': 'Complex Pipes',
  'Helix connection issues': 'Helix connection issues',
  'Cloud 2 Cloud': 'Cloud 2 Cloud',
  Priority: 'Priority',
  Holiday: 'Holiday',
  'Missing Parts': 'Missing Parts',
  'Shipping Delay': 'Shipping Delay',
  'EB Issues': 'EB Issues',
  'Communication Issues': 'Communication Issues',
  'Installation Validation Fails / Control Validation': 'Installation Validation Fails / Control Validation',
  'External Control System': 'External Control System',
  "Sensors' Issues": "Sensors' Issues",
  "Controllers' Issues": "Controllers' Issues",
  "Compressors' Issues": "Compressors' Issues",
  'Design Mismatch': 'Design Mismatch',
  'Customer Not Responding': 'Customer Not Responding',
  'Waiting for equipment': 'Waiting for equipment',
  'Scheduling Issues': 'Scheduling Issues',
  Controlled: 'Controlled',
  'Not Controlled': 'Not Controlled',
  'Moving stage...': 'Moving stage...',
  'Move stage success!': 'Move stage success!',
  'Move stage failed': 'Move stage failed',
  'new stage:': 'new stage:',
  'Start Date': 'Start Date',
  'End Date': 'End Date',
  'Select User': 'Select User',
  'Save Changes': 'Save Changes',
  'Edit Map': 'Edit P&ID',
  searchByNumber: 'Search by number',
  selectAtleastOneCompressor: 'Please select at least one Compressor for Compressor Failure.',
  flowKPIOrPressureKPI: 'Flow KPI or Pressure KPI',
  compressorFailure: 'Compressor Failure',
  appliedFilters: 'Applied Filters',
  scenario: 'Scenario',
  scenarioName: 'Scenario Name',
  selectScenario: 'Select Scenario',
  selectCompressors: 'Select Compressors',
  ignoreFallbackCompressors: 'Compressors excluded from fallback scenario generation',
  ignoreFallbackCompressorsTooltip:
    'Fallback scenarios are generated only for a defined set of compressors. This set is determined by the intersection of:',
  ignoreFallbackCompressorsTooltipBullet1: 'Compressors currently available in the system',
  ignoreFallbackCompressorsTooltipBullet2: 'Compressors not included in the excluded list.',
  ignoreFallbackCompressorsTooltipNote:
    'Compressors listed here are intentionally ignored by the fallback strategy—for example, because they are known to be disconnected or because no fallback is required if they fail.',
  saveScenario: 'Save',
  newFallbackScenario: 'New Fallback Scenario',
  createACustomTable: 'Create a custom table',
  useExistingTable: 'Use Existing Table',
  createANewFallbackScenario: 'Create a new fallback scenario',
  pickOneToBuildOnEitherReuseAnExistingTableOrLetTheEngineSuggestASmartStartingPoint:
    'Pick one to build on. Either reuse an existing table or let the engine suggest a smart starting point.',
  selectATableNumber: 'Select a table number',
  filterFailScenario: 'Filter fail scenario',
  refineScenariosByKPIAndComponents: 'Refine scenarios by KPI and components',
  validationError: 'Validation Error',
  baseFallbackOnTable: 'Base fallback on table',
  'Exit Edit Mode': 'Exit Edit Mode',
  'Exit & Save Draft': 'Exit & Save Draft',
  'Exit & Discard': 'Exit & Discard',
  'Last Updated': 'Last Updated',
  April: 'April',
  'Click a pipe to add sensors/filters/valves.': 'Click a pipe to add sensors/filters/valves.',
  'Select Model': 'Select Model',
  'Select Controller': 'Select Controller',
  'No Controller': 'No Controller',
  usd: '$',
  ils: '₪',
  euro: '€',
  regionRequired: 'Region is required',
  Error: 'Error',
  'No stages found': 'No stages found',
  editDeviceDetails: 'Edit {{device}} details',
  tank: 'Tank',
  dryer: 'Dryer',
  'production line': 'Production line',
  number: 'Number',
  modelSpec: 'Model spec',
  controller: 'Controller',
  bandsControl: 'Bands control',
  'five loop': 'Five loop',
  type: 'Type',
  selectType: 'Select type',
  selectController: 'Select controller',
  selectModelSpec: 'Select model spec',
  Capacity: 'Capacity',
  SerialImportedFromSalesforce: 'This serial number was imported from Salesforce and cannot be modified',
  NoControllerProxyNotEditable: 'No Controller / Proxy models are not editable.',
  AND: 'And',
  scenarioBasedOn: 'Scenario based on',
  failureOf: 'Failure of',
  flowKPIOrPressureKPIFailure: 'Flow KPI or Pressure KPI Failure',
  newFallback: 'New Fallback',
  currentlyActive: 'Currently active',
  view: 'View',
  removeScenario: 'Remove',
  updateScenario: 'Update',
  firstApplyFiltersToDefineYourScenario: 'First apply filters to define your scenario',
  applyFiltersAndContinue: 'Apply filters and continue',
  fallbackScenarioSavedSuccessfully: 'Fallback scenario saved successfully',
  thisScenarioAlreadyExists: 'This scenario already exists.',
  confirmSaveScenario:
    'Saving fallback scenario, will automatically update the draft. Are you sure you want to save this scenario?',
  confirmUpdateScenario:
    'Updating fallback scenario, will automatically update the draft. Are you sure you want to update this scenario?',
  confirmRemoveScenario:
    'Removing fallback scenario, will automatically update the draft. Are you sure you want to remove this scenario?',
  fallbackScenario: 'Fallback',
  flowKPI: 'Flow KPI',
  pressureKPI: 'Pressure KPI',
  invalidScenario:
    'Invalid scenario as Compressor Failure, Flow KPI Failure, and Pressure KPI Failure cannot be applied together.',
  set0ForACompressor: 'Set 0 for a {} compressor',
  trimmer: 'trimmer',
  setNegativeValueForCompressorsNotToBeIncluded: 'Set a negative value for compressors {} to be included',
  not: 'not',
  setPositiveValueForCompressors: 'Set positive value for {} compressors',
  base: 'base',
  orderIsRequired: 'Order is required',
  atLeastOneSetpointMustHavePositiveOrder: 'At least one setpoint must have a positive order',
  mixedStationNotSupported: 'Engine 1.5 currently does not support mixed stations',
  'Station design readiness': 'Station design readiness',
  'Show missing data': 'Show missing data',
  'Model specs missing': 'Model specs missing',
  'Missing specs info': 'Missing specs info',
  'Missing Info': 'Missing Info',
  comps: 'comps',
  Missing: 'Missing',
  images: 'images',
  'Add model spec': 'Add model spec',
  'Add images': 'Add images',
  'Missing data & image': 'Missing data & image',
  sensor: 'sensor',
  'Add data': 'Add data',
  'Engine version is set by engine expert': 'Engine version is set by engine expert',
  favourite: 'Favorites',
  favorite: 'Favorite',
  allOthers: 'All others',
  showcase: 'Showcase',
  addToFavorite: 'Add to favorite',
  removeFromFavorite: 'Remove from favorite',
  selectConnectTo: 'Select connected to',
  connectTo: 'Connect to',
  connectFrom: 'Connect from',
  compressorDetails: 'Compressor details',
  tankDetails: 'Tank details',
  dryerDetails: 'Dryer details',
  'production lineDetails': 'Production line details',
  boosterDetails: 'Booster details',
  onDeviceSensor: 'On device sensor',
  addOnDeviceSensor: 'Add on device sensor',
  addSensor: 'Add sensor',
  unsavedChanges: 'You have unsaved changes. Please save or discard them before changing the tab.',
  'Remove this asset?': 'Remove this asset?',
  'This will remove the selected asset from the map. This action can’t be undone.':
    'This will remove the selected asset from the map. This action can’t be undone.',
  'Deleting the device will delete its historical data, do you want to proceed?':
    'Deleting the device will delete its historical data, do you want to proceed?',
  'Remove Asset': 'Remove Asset',

  // Report Tab Page
  reportDetails: 'Report details',
  dateCreated: 'Date created',
  createdBy: 'Created by',
  status: 'Status',
  totalReports: 'Report',
  createNewReport: 'Create New Report',
  searchByDateCreatorOrStatus: 'Search by date, creator or status',
  inProgress: 'In progress',
  failed: 'Error',
  inDraft: 'Draft',
  unknown: 'Unknown',
  failedToDownloadReportFile: 'Failed to download report file',
  downloadingFile: 'Downloading file...',
  fileDownloaded: 'File downloaded successfully',
  deleteReport: 'Delete Report',
  areYouSureYouWantToDeleteThisReport: 'Are you sure you want to delete this report?',
  reportDeletedSuccessfully: 'Report deleted successfully',
  failedToDeleteReport: 'Failed to delete report',
  failedToUploadReport: 'Failed to upload report',
  reportUploadedSuccessfully: 'Report uploaded successfully',
  anErrorOccurred: 'An error occurred',
  onlyPowerPointFilesAllowed: 'Only PowerPoint files (.pptx, .ppt) are allowed',
  pleaseSelectADateRange: 'Please select a date range',
  reportRequestedSuccessfully:
    'The report generation may take up to 15 minutes. Once it is done the status in this screen will change to Draft and the Edit and Publish actions will be enabled.',
  failedToRequestReport: 'Failed to request report',
  selectDates: 'Select Dates',
  noteForReportGeneration:
    "Note: Report generation may take a few minutes. You will be notified by email once it's complete.",
  reportTimeFrameUpTo2Weeks: 'Report time frame can be up to 2 weeks.',
  generateReport: 'Generate Report',
  reportPublishedSuccessfully: 'Report published successfully',
  reportPublishedInProgress:
    'The report publishing may take a couple of minutes. Once it is done the status in this screen will change to Published, the View action will be enabled and the customer will be able to see this report.',
  failedToPublishReport: 'Failed to publish report',
  addBusinessImpactBeforePublishing: 'Add business impact before publishing',
  pleaseEstimateItsPotentialBusinessImpact:
    "Please estimate its potential business impact. This helps communicate the report's value to your customer.",
  estimatedValue: 'Estimated value ($)',
  valueIsRequiredAndMustBeHigherThan0ToPublish: 'Value is required and must be higher than 0 to publish',
  noteOncePublishedThisReportWillBeAutomaticallySharedWithAllRecipients:
    'Note: Once published, this report will be automatically shared with all recipients.',
  publishReport: 'Publish Report',
  Upload: 'Upload',
  Publish: 'Publish',
  View: 'View',
  seeTheFullPictureOfYourReportPerformance: 'See the full picture of your report performance',
  createAToTrackAnalyzeAndSharePerformance: 'Create a report to track, analyze, and share performance',
  tryNewReport: 'Try New Report',
  loadingReports: 'Loading reports...',
  generatingReports: 'Generating reports...',
  noReportsAvailable: 'No reports available',
  sentForPublishing: 'Sent for publishing',
  mapEditor: 'Map Editor',
  loadingPIDEditor: 'Loading P&ID Editor',
  loadingPIDEditorDescription:
    'In the next screen, you can add or edit assets and save, including an option to save as a draft',
  openDrawerTooltip: 'Click to reopen the drawer with all available assets',
  addNewAssets: 'Add new assets',
  availableAssets: 'Available assets',
  clickToAdd: 'Click to add',
  comp: 'Comp',
  desDryer: 'Des. Dryer',
  refDryer: 'Ref. Dryer',
  prodFloor: 'Prod. Floor',
  new: 'New {{device}}',
  addNew: 'Add new {{device}}',
  connect: 'Connect',
  from: 'From',
  to: 'To',
  connectionSelectorDescription: 'See connected assets on the left and adjust if needed.',
  newSerial: '{{serialNumber}} (New serial)',
  selectOrTypeNumber: 'Select or type number',
  "This will remove the selected asset from the map and its on-devices. This action can't be undone.":
    "This will remove the selected asset from the map and its on-devices. This action can't be undone.",
  'Apply Changes to P&ID?': 'Apply Changes to P&ID?',
  "These changes will be saved and added to the station's P&ID. This action may affect system configuration and visibility.":
    "These changes will be saved and added to the station's P&ID. This action may affect system configuration and visibility.",
  'Confirm and Save': 'Confirm and Save',
  'Device deleted successfully': 'Device deleted successfully',
  'Failed to delete device': 'Failed to delete device',
  'Draft Activated successfully': 'Draft Activated successfully',
  'Failed to save changes': 'Failed to save changes',
  assetsMustHaveConnectionsUpdated: 'Assets must have connections updated',
  kpiChanges:
    'A new engine strategy must be defined and published since the Sensors KPI Configuration has been modified. Please review the changes and publish configuration.',
  kpiChangesAndPIDChanges:
    'A new engine strategy must be defined and published since the station P&ID and sensors KPI configuration has changed. Below is the list of assets that affect the control strategy:',
  dynamicControlInvalidStationStage:
    'The dynamic control cannot be activated since the station is not in Subscription/Control Prep stage.',

  fallbackScenarioForAllCompressorsFailureCannotBeDefined:
    'Fallback scenario for all compressors failure cannot be defined',
  loadingDocument: 'Loading document...',
  ratedPower: 'Rated Power',
  allAssetsMustBeConnected: 'All assets must be connected.',
  orphanAssets: 'Orphan assets',
  deviceNotConnected: 'All assets must be connected. Device {{ deviceName }} is not connected.',

  // AI Assistant / Insights
  InsightStatusNew: 'New',
  InsightStatusPublished: 'Published',
  InsightStatusArchived: 'Archived',
  InsightTypeEnergy: 'Energy',
  InsightTypeRisk: 'Risk',
  InsightTypeMaintenance: 'Maintenance',
  InsightTypeOther: 'Other',
  StationLevel: 'Station Level',
  IOTInsight: 'IOT Insight',
  ManualInsight: 'Manual Insight',
  ShowInsightDetails: 'Show me more details about the {{name}} insight please',
  AvailableInsightsCount: 'Available Insights ({{count}})',
  ArchivedInsightsCount: 'Archived ({{count}})',
  SelectInsightMessage: "Select an insight to see what's happening in the station and what actions you can take.",
  StationInsights: 'Station Insights',
  AddInsightsToConversation: 'Add Insights to conversation',
  GetStartedTitle: 'Get started by exploring your station or asking AI for help.',
  SelectInsightDescription: 'Select an insight from the list to view detailed information and recommended actions.',
  ExploreStationPerformance: 'You can also start with one of the following options to explore station performance:',
  SalesAssistantHelperText: 'Sales Assistant can help you analyse this station and prepare for customer conversations',
  AskAnything: 'Ask anything...',
  SocketResponseTimeoutError: 'Something went wrong. The response took too long to arrive.',
  ResendMessage: 'Resend',
  Archive: 'Archive',
  NewConversation: 'New Conversation',
  Last7Days: 'Last 7 days',
  ExploreYourStationInsightsOrAskAIForHelp: 'Explore your station insights or ask AI for help',
  YourSalesAssistantDescription:
    'Your Sales Assistant. Gain comprehensive insights, identify critical issues, and prepare for smarter customer conversations—all in one place.',
  AskingAIForHelp: 'Asking AI for help',
  GetStationOverview: 'Station Overview',
  ExploreStationOverview: 'Explore station overview',
  PrepareForQuarterlyMeeting: 'Prepare for a quarterly meeting',
  ComparePerformanceToPeers: 'Compare performance to peers',
  StationOverviewPrompt: 'Can you give me an overview of this station current status?',
  QuarterlyMeetingPrompt: 'Help me prepare for a quarterly customer meeting for this station',
  PendingPotentialValue: 'Pending potential value',
  ValueByType: 'Value by type',
  Published: 'Published',
  NoInsights: 'No insights',
  NoPublishedInsights: 'No published insights',
  NoArchivedInsights: 'No archived insights',
  CreateNewInsight: 'Create New Insight',
  NoDraftInsightsTitle: 'No insights right now',
  NoOpenedInsightsTitle: 'No Opened insights right now',
  NoArchivedInsightsTitle: 'No Archived insights right now',
  LetsMakeFirstOneTogether: "Let's make the first one together!",
  EmptyStateDescription:
    "The AI is already analysing your station's IoT data. While it's looking for automatic opportunities, you can jump in create the first insight manually and turn it into revenue today.",
  Salesmate: 'Salesmate',
  addressNotInserted: 'Address Not Inserted',
  addressNotInsertedWarning:
    "Address has not been inserted. Current site's region is {{siteRegion}}. If you’ll like to change this, please input the site's address.",
  Proceed: 'Proceed',
};

export default en;
